// AUTO-GENERATED by scripts/genFontCatalog.mjs — DO NOT EDIT BY HAND.
// Source: https://fonts.google.com/metadata/fonts (Google Fonts, OFL/Apache, free for commercial use).
// Tuple shape: [family, category, weights, hasItalic(0|1), popularityRank]
import type { FontCategory } from './catalog'

export const GOOGLE_FONTS_RAW: [string, FontCategory, number[], 0 | 1, number][] = [
  ["Roboto","sans-serif",[100,200,300,400,500,600,700,800,900],1,2],
  ["Open Sans","sans-serif",[300,400,500,600,700,800],1,3],
  ["Google Sans","sans-serif",[400,500,600,700],1,4],
  ["Inter","sans-serif",[100,200,300,400,500,600,700,800,900],1,5],
  ["Montserrat","sans-serif",[100,200,300,400,500,600,700,800,900],1,6],
  ["Poppins","sans-serif",[100,200,300,400,500,600,700,800,900],1,8],
  ["Noto Sans JP","sans-serif",[100,200,300,400,500,600,700,800,900],0,9],
  ["Lato","sans-serif",[100,300,400,700,900],1,10],
  ["Arimo","sans-serif",[400,500,600,700],1,13],
  ["Roboto Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],1,14],
  ["Roboto Mono","monospace",[100,200,300,400,500,600,700],1,16],
  ["Oswald","sans-serif",[200,300,400,500,600,700],0,18],
  ["Noto Sans","sans-serif",[100,200,300,400,500,600,700,800,900],1,19],
  ["Raleway","sans-serif",[100,200,300,400,500,600,700,800,900],1,21],
  ["Nunito","sans-serif",[200,300,400,500,600,700,800,900,1000],1,23],
  ["DM Sans","sans-serif",[100,200,300,400,500,600,700,800,900,1000],1,24],
  ["Nunito Sans","sans-serif",[200,300,400,500,600,700,800,900,1000],1,25],
  ["Playfair Display","serif",[400,500,600,700,800,900],1,26],
  ["Rubik","sans-serif",[300,400,500,600,700,800,900],1,27],
  ["Archivo Black","sans-serif",[400],0,28],
  ["Roboto Slab","serif",[100,200,300,400,500,600,700,800,900],0,29],
  ["Noto Sans KR","sans-serif",[100,200,300,400,500,600,700,800,900],0,31],
  ["Ubuntu","sans-serif",[300,400,500,700],1,33],
  ["Kanit","sans-serif",[100,200,300,400,500,600,700,800,900],1,34],
  ["Outfit","sans-serif",[100,200,300,400,500,600,700,800,900],0,35],
  ["Merriweather","serif",[300,400,500,600,700,800,900],1,36],
  ["Manrope","sans-serif",[200,300,400,500,600,700,800],0,37],
  ["Noto Sans TC","sans-serif",[100,200,300,400,500,600,700,800,900],0,38],
  ["Bebas Neue","sans-serif",[400],0,39],
  ["Work Sans","sans-serif",[100,200,300,400,500,600,700,800,900],1,40],
  ["PT Sans","sans-serif",[400,700],1,41],
  ["Prompt","sans-serif",[100,200,300,400,500,600,700,800,900],1,42],
  ["Lora","serif",[400,500,600,700],1,43],
  ["Black Ops One","display",[400],0,44],
  ["Mulish","sans-serif",[200,300,400,500,600,700,800,900,1000],1,45],
  ["Saira","sans-serif",[100,200,300,400,500,600,700,800,900],1,46],
  ["Bricolage Grotesque","sans-serif",[200,300,400,500,600,700,800],0,47],
  ["Figtree","sans-serif",[300,400,500,600,700,800,900],1,48],
  ["Barlow","sans-serif",[100,200,300,400,500,600,700,800,900],1,49],
  ["Share Tech","sans-serif",[400],0,50],
  ["IBM Plex Sans","sans-serif",[100,200,300,400,500,600,700],1,51],
  ["Smooch Sans","sans-serif",[100,200,300,400,500,600,700,800,900],0,52],
  ["Source Sans 3","sans-serif",[200,300,400,500,600,700,800,900],1,53],
  ["Plus Jakarta Sans","sans-serif",[200,300,400,500,600,700,800],1,54],
  ["Quicksand","sans-serif",[300,400,500,600,700],0,55],
  ["Karla","sans-serif",[200,300,400,500,600,700,800],1,56],
  ["Jost","sans-serif",[100,200,300,400,500,600,700,800,900],1,57],
  ["Fira Sans","sans-serif",[100,200,300,400,500,600,700,800,900],1,58],
  ["Titillium Web","sans-serif",[200,300,400,600,700,900],1,59],
  ["Archivo","sans-serif",[100,200,300,400,500,600,700,800,900],1,60],
  ["Noto Serif","serif",[100,200,300,400,500,600,700,800,900],1,61],
  ["Heebo","sans-serif",[100,200,300,400,500,600,700,800,900],0,62],
  ["PT Serif","serif",[400,700],1,65],
  ["Dancing Script","handwriting",[400,500,600,700],0,66],
  ["Source Code Pro","monospace",[200,300,400,500,600,700,800,900],1,67],
  ["Fjalla One","sans-serif",[400],0,68],
  ["Inconsolata","monospace",[200,300,400,500,600,700,800,900],0,69],
  ["Lobster Two","display",[400,700],1,71],
  ["Noto Serif JP","serif",[200,300,400,500,600,700,800,900],0,72],
  ["Noto Sans SC","sans-serif",[100,200,300,400,500,600,700,800,900],0,73],
  ["Cormorant Garamond","serif",[300,400,500,600,700],1,74],
  ["Libre Baskerville","serif",[400,500,600,700],1,76],
  ["Anton","sans-serif",[400],0,77],
  ["JetBrains Mono","monospace",[100,200,300,400,500,600,700,800],1,78],
  ["Libre Franklin","sans-serif",[100,200,300,400,500,600,700,800,900],1,79],
  ["Barlow Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],1,80],
  ["Changa One","display",[400],1,81],
  ["Space Grotesk","sans-serif",[300,400,500,600,700],0,82],
  ["Josefin Sans","sans-serif",[100,200,300,400,500,600,700],1,84],
  ["Alfa Slab One","display",[400],0,85],
  ["Cairo","sans-serif",[200,300,400,500,600,700,800,900,1000],0,86],
  ["Nanum Gothic","sans-serif",[400,700,800],0,87],
  ["Instrument Serif","serif",[400],1,88],
  ["EB Garamond","serif",[400,500,600,700,800],1,89],
  ["Noto Sans Telugu","sans-serif",[100,200,300,400,500,600,700,800,900],0,90],
  ["Ramabhadra","sans-serif",[400],0,91],
  ["Assistant","sans-serif",[200,300,400,500,600,700,800],0,92],
  ["Public Sans","sans-serif",[100,200,300,400,500,600,700,800,900],1,93],
  ["Anek Telugu","sans-serif",[100,200,300,400,500,600,700,800],0,94],
  ["Noto Sans Khmer","sans-serif",[100,200,300,400,500,600,700,800,900],0,95],
  ["Hind Siliguri","sans-serif",[300,400,500,600,700],0,96],
  ["M PLUS Rounded 1c","sans-serif",[100,300,400,500,700,800,900],0,97],
  ["Roboto Flex","sans-serif",[100,200,300,400,500,600,700,800,900,1000],0,98],
  ["Schibsted Grotesk","sans-serif",[400,500,600,700,800,900],1,100],
  ["Sora","sans-serif",[100,200,300,400,500,600,700,800],0,102],
  ["Cabin","sans-serif",[400,500,600,700],1,103],
  ["Dosis","sans-serif",[200,300,400,500,600,700,800],0,104],
  ["Inter Tight","sans-serif",[100,200,300,400,500,600,700,800,900],1,105],
  ["Caveat","handwriting",[400,500,600,700],0,106],
  ["Mukta","sans-serif",[200,300,400,500,600,700,800],0,108],
  ["Red Hat Display","sans-serif",[300,400,500,600,700,800,900],1,109],
  ["Bitter","serif",[100,200,300,400,500,600,700,800,900],1,110],
  ["Lilita One","display",[400],0,111],
  ["Rajdhani","sans-serif",[300,400,500,600,700],0,112],
  ["Hind","sans-serif",[300,400,500,600,700],0,114],
  ["Fredoka","sans-serif",[300,400,500,600,700],0,115],
  ["Oxygen","sans-serif",[300,400,700],0,116],
  ["Lexend","sans-serif",[100,200,300,400,500,600,700,800,900],0,117],
  ["Orbitron","sans-serif",[400,500,600,700,800,900],0,118],
  ["Crimson Text","serif",[400,600,700],1,119],
  ["Exo 2","sans-serif",[100,200,300,400,500,600,700,800,900],1,120],
  ["Bungee","display",[400],0,121],
  ["Overpass","sans-serif",[100,200,300,400,500,600,700,800,900],1,124],
  ["Urbanist","sans-serif",[100,200,300,400,500,600,700,800,900],1,125],
  ["Google Sans Flex","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],0,126],
  ["Tajawal","sans-serif",[200,300,400,500,700,800,900],0,127],
  ["Source Serif 4","serif",[200,300,400,500,600,700,800,900],1,128],
  ["Slabo 27px","serif",[400],0,130],
  ["Pacifico","handwriting",[400],0,131],
  ["Merriweather Sans","sans-serif",[300,400,500,600,700,800],1,132],
  ["Noto Sans Arabic","sans-serif",[100,200,300,400,500,600,700,800,900],0,133],
  ["Barlow Semi Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],1,134],
  ["Fraunces","serif",[100,200,300,400,500,600,700,800,900],1,135],
  ["Geist","sans-serif",[100,200,300,400,500,600,700,800,900],1,136],
  ["DM Serif Display","serif",[400],1,137],
  ["Abel","sans-serif",[400],0,138],
  ["Cinzel","serif",[400,500,600,700,800,900],0,139],
  ["Arvo","serif",[400,700],1,140],
  ["PT Sans Narrow","sans-serif",[400,700],0,141],
  ["Lobster","display",[400],0,142],
  ["DM Mono","monospace",[300,400,500],1,143],
  ["Albert Sans","sans-serif",[100,200,300,400,500,600,700,800,900],1,144],
  ["Noto Sans Thai","sans-serif",[100,200,300,400,500,600,700,800,900],0,145],
  ["IBM Plex Mono","monospace",[100,200,300,400,500,600,700],1,146],
  ["Teko","sans-serif",[300,400,500,600,700],0,147],
  ["M PLUS 1p","sans-serif",[100,300,400,500,700,800,900],0,149],
  ["Bodoni Moda","serif",[400,500,600,700,800,900],1,150],
  ["Epilogue","sans-serif",[100,200,300,400,500,600,700,800,900],1,151],
  ["Comfortaa","display",[300,400,500,600,700],0,152],
  ["Asap","sans-serif",[100,200,300,400,500,600,700,800,900],1,153],
  ["Almarai","sans-serif",[300,400,700,800],0,154],
  ["Instrument Sans","sans-serif",[400,500,600,700],1,155],
  ["Alumni Sans","sans-serif",[100,200,300,400,500,600,700,800,900],1,156],
  ["Chakra Petch","sans-serif",[300,400,500,600,700],1,157],
  ["Be Vietnam Pro","sans-serif",[100,200,300,400,500,600,700,800,900],1,158],
  ["Newsreader","serif",[200,300,400,500,600,700,800],1,159],
  ["Lexend Deca","sans-serif",[100,200,300,400,500,600,700,800,900],0,160],
  ["Geist Mono","monospace",[100,200,300,400,500,600,700,800,900],1,161],
  ["Zen Kaku Gothic New","sans-serif",[300,400,500,700,900],0,162],
  ["Maven Pro","sans-serif",[400,500,600,700,800,900],0,164],
  ["Play","sans-serif",[400,700],0,165],
  ["Questrial","sans-serif",[400],0,166],
  ["Abril Fatface","display",[400],0,167],
  ["Fugaz One","display",[400],0,168],
  ["Saira Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],0,169],
  ["Fira Sans Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],1,170],
  ["ABeeZee","sans-serif",[400],1,171],
  ["Nanum Myeongjo","serif",[400,700,800],0,172],
  ["Shadows Into Light","handwriting",[400],0,173],
  ["Archivo Narrow","sans-serif",[400,500,600,700],1,174],
  ["Marcellus","serif",[400],0,175],
  ["Geologica","sans-serif",[100,200,300,400,500,600,700,800,900],0,177],
  ["Sofia Sans","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],1,178],
  ["Exo","sans-serif",[100,200,300,400,500,600,700,800,900],1,179],
  ["Varela Round","sans-serif",[400],0,180],
  ["Google Sans Code","monospace",[300,400,500,600,700,800],1,181],
  ["Space Mono","monospace",[400,700],1,182],
  ["Domine","serif",[400,500,600,700],0,183],
  ["IBM Plex Sans Arabic","sans-serif",[100,200,300,400,500,600,700],0,184],
  ["Hanken Grotesk","sans-serif",[100,200,300,400,500,600,700,800,900],1,185],
  ["Zilla Slab","serif",[300,400,500,600,700],1,186],
  ["Onest","sans-serif",[100,200,300,400,500,600,700,800,900],0,187],
  ["Gravitas One","display",[400],0,188],
  ["League Spartan","sans-serif",[100,200,300,400,500,600,700,800,900],0,189],
  ["Press Start 2P","display",[400],0,190],
  ["IBM Plex Serif","serif",[100,200,300,400,500,600,700],1,191],
  ["Cormorant","serif",[300,400,500,600,700],1,192],
  ["Spectral","serif",[200,300,400,500,600,700,800],1,193],
  ["Unbounded","sans-serif",[200,300,400,500,600,700,800,900],0,194],
  ["Zen Maru Gothic","sans-serif",[300,400,500,700,900],0,195],
  ["Libre Barcode 39","display",[400],0,196],
  ["Indie Flower","handwriting",[400],0,197],
  ["Great Vibes","handwriting",[400],0,198],
  ["Kalam","handwriting",[300,400,700],0,199],
  ["Noto Serif SC","serif",[200,300,400,500,600,700,800,900],0,200],
  ["Noto Serif TC","serif",[200,300,400,500,600,700,800,900],0,201],
  ["Yanone Kaffeesatz","sans-serif",[200,300,400,500,600,700],0,202],
  ["Noto Sans Tamil","sans-serif",[100,200,300,400,500,600,700,800,900],0,203],
  ["Noto Serif KR","serif",[200,300,400,500,600,700,800,900],0,204],
  ["Yellowtail","handwriting",[400],0,206],
  ["Permanent Marker","handwriting",[400],0,207],
  ["Luckiest Guy","display",[400],0,208],
  ["Sarabun","sans-serif",[100,200,300,400,500,600,700,800],1,209],
  ["Syne","sans-serif",[400,500,600,700,800],0,210],
  ["Angkor","display",[400],0,211],
  ["Frank Ruhl Libre","serif",[300,400,500,600,700,800,900],0,212],
  ["Asap Condensed","sans-serif",[200,300,400,500,600,700,800,900],1,213],
  ["Noto Kufi Arabic","sans-serif",[100,200,300,400,500,600,700,800,900],0,214],
  ["Roboto Serif","serif",[100,200,300,400,500,600,700,800,900],1,215],
  ["Rethink Sans","sans-serif",[400,500,600,700,800],1,216],
  ["Rowdies","display",[300,400,700],0,217],
  ["Satisfy","handwriting",[400],0,218],
  ["Noto Sans Devanagari","sans-serif",[100,200,300,400,500,600,700,800,900],0,219],
  ["Vollkorn","serif",[400,500,600,700,800,900],1,220],
  ["Righteous","display",[400],0,221],
  ["Antic Slab","serif",[400],0,222],
  ["Amiri","serif",[400,700],1,223],
  ["Signika","sans-serif",[300,400,500,600,700],0,224],
  ["IBM Plex Sans Condensed","sans-serif",[100,200,300,400,500,600,700],1,225],
  ["News Cycle","sans-serif",[400,700],0,226],
  ["Catamaran","sans-serif",[100,200,300,400,500,600,700,800,900],0,227],
  ["Readex Pro","sans-serif",[200,300,400,500,600,700],0,228],
  ["Viga","sans-serif",[400],0,229],
  ["Russo One","sans-serif",[400],0,230],
  ["Alegreya Sans","sans-serif",[100,300,400,500,700,800,900],1,231],
  ["DM Serif Text","serif",[400],1,232],
  ["Puritan","sans-serif",[400,700],1,233],
  ["Cantarell","sans-serif",[400,700],1,234],
  ["Hammersmith One","sans-serif",[400],0,235],
  ["Advent Pro","sans-serif",[100,200,300,400,500,600,700,800,900],1,236],
  ["Literata","serif",[200,300,400,500,600,700,800,900],1,237],
  ["Encode Sans","sans-serif",[100,200,300,400,500,600,700,800,900],0,238],
  ["Courier Prime","monospace",[400,700],1,239],
  ["Cardo","serif",[400,700],1,241],
  ["Red Hat Text","sans-serif",[300,400,500,600,700],1,242],
  ["Shippori Mincho","serif",[400,500,600,700,800],0,243],
  ["Noto Sans Display","sans-serif",[100,200,300,400,500,600,700,800,900],1,244],
  ["Atkinson Hyperlegible","sans-serif",[400,700],1,245],
  ["Alata","sans-serif",[400],0,246],
  ["VT323","monospace",[400],0,247],
  ["Amatic SC","handwriting",[400,700],0,248],
  ["Sawarabi Mincho","serif",[400],0,249],
  ["Fira Code","monospace",[300,400,500,600,700],0,250],
  ["Tinos","serif",[400,700],1,251],
  ["Unna","serif",[400,700],1,252],
  ["Hind Madurai","sans-serif",[300,400,500,600,700],0,253],
  ["Titan One","display",[400],0,254],
  ["Gothic A1","sans-serif",[100,200,300,400,500,600,700,800,900],0,255],
  ["Montserrat Alternates","sans-serif",[100,200,300,400,500,600,700,800,900],1,256],
  ["Special Elite","display",[400],0,257],
  ["Acme","sans-serif",[400],0,258],
  ["Tenor Sans","sans-serif",[400],0,259],
  ["Baskervville","serif",[400,500,600,700],1,260],
  ["Kumbh Sans","sans-serif",[100,200,300,400,500,600,700,800,900],0,261],
  ["Noto Nastaliq Urdu","serif",[400,500,600,700],0,262],
  ["Sawarabi Gothic","sans-serif",[400],0,263],
  ["Noto Naskh Arabic","serif",[400,500,600,700],0,264],
  ["Actor","sans-serif",[400],0,265],
  ["Bangers","display",[400],0,266],
  ["Bree Serif","serif",[400],0,267],
  ["Prata","serif",[400],0,268],
  ["Berkshire Swash","handwriting",[400],0,269],
  ["LINE Seed JP","sans-serif",[100,400,700,800],0,270],
  ["Crimson Pro","serif",[200,300,400,500,600,700,800,900],1,271],
  ["Cousine","monospace",[400,700],1,272],
  ["Alegreya","serif",[400,500,600,700,800,900],1,273],
  ["Changa","sans-serif",[200,300,400,500,600,700,800],0,274],
  ["Share Tech Mono","monospace",[400],0,275],
  ["Creepster","display",[400],0,277],
  ["Lexend Giga","sans-serif",[100,200,300,400,500,600,700,800,900],0,278],
  ["Patua One","display",[400],0,279],
  ["Libre Caslon Text","serif",[400,700],1,280],
  ["Playfair","serif",[300,400,500,600,700,800,900],1,281],
  ["League Gothic","sans-serif",[400],0,282],
  ["Yantramanav","sans-serif",[100,300,400,500,700,900],0,283],
  ["Rock Salt","handwriting",[400],0,284],
  ["Chivo","sans-serif",[100,200,300,400,500,600,700,800,900],1,285],
  ["IBM Plex Sans JP","sans-serif",[100,200,300,400,500,600,700],0,286],
  ["Aleo","serif",[100,200,300,400,500,600,700,800,900],1,287],
  ["Comic Neue","handwriting",[300,400,700],1,288],
  ["Passion One","display",[400,700,900],0,289],
  ["Rubik Mono One","sans-serif",[400],0,290],
  ["BIZ UDPGothic","sans-serif",[400,700],0,291],
  ["Crete Round","serif",[400],1,293],
  ["Courgette","handwriting",[400],0,294],
  ["Martel","serif",[200,300,400,600,700,800,900],0,295],
  ["Noticia Text","serif",[400,700],1,296],
  ["Baloo 2","display",[400,500,600,700,800],0,297],
  ["Mitr","sans-serif",[200,300,400,500,600,700],0,298],
  ["Gelasio","serif",[400,500,600,700],1,299],
  ["Noto Sans Bengali","sans-serif",[100,200,300,400,500,600,700,800,900],0,300],
  ["Unica One","display",[400],0,301],
  ["Jura","sans-serif",[300,400,500,600,700],0,302],
  ["Old Standard TT","serif",[400,700],1,303],
  ["Oxanium","display",[200,300,400,500,600,700,800],0,304],
  ["Commissioner","sans-serif",[100,200,300,400,500,600,700,800,900],0,305],
  ["Monoton","display",[400],0,306],
  ["Khand","sans-serif",[300,400,500,600,700],0,307],
  ["Philosopher","sans-serif",[400,700],1,308],
  ["Rokkitt","serif",[100,200,300,400,500,600,700,800,900],1,309],
  ["Noto Sans Mono","sans-serif",[100,200,300,400,500,600,700,800,900],0,310],
  ["Signika Negative","sans-serif",[300,400,500,600,700],0,311],
  ["Sofia Sans Condensed","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],1,312],
  ["Allura","handwriting",[400],0,313],
  ["Kaushan Script","handwriting",[400],0,314],
  ["Gabarito","display",[400,500,600,700,800,900],0,315],
  ["Francois One","sans-serif",[400],0,316],
  ["Chango","display",[400],0,317],
  ["Rammetto One","display",[400],0,318],
  ["Zen Old Mincho","serif",[400,500,600,700,900],0,319],
  ["Golos Text","sans-serif",[400,500,600,700,800,900],0,320],
  ["STIX Two Text","serif",[400,500,600,700],1,321],
  ["Kosugi Maru","sans-serif",[400],0,322],
  ["Alexandria","sans-serif",[100,200,300,400,500,600,700,800,900],0,323],
  ["Patrick Hand","handwriting",[400],0,324],
  ["Eater","display",[400],0,325],
  ["Biryani","sans-serif",[200,300,400,600,700,800,900],0,326],
  ["Forum","display",[400],0,328],
  ["Gruppo","sans-serif",[400],0,329],
  ["Josefin Slab","serif",[100,200,300,400,500,600,700],1,330],
  ["Sen","sans-serif",[400,500,600,700,800],0,331],
  ["Amaranth","sans-serif",[400,700],1,332],
  ["Chelsea Market","display",[400],0,333],
  ["Krub","sans-serif",[200,300,400,500,600,700],1,334],
  ["Bai Jamjuree","sans-serif",[200,300,400,500,600,700],1,336],
  ["Sacramento","handwriting",[400],0,337],
  ["Nanum Gothic Coding","handwriting",[400,700],0,338],
  ["Libre Bodoni","serif",[400,500,600,700],1,339],
  ["Staatliches","display",[400],0,340],
  ["Antonio","sans-serif",[100,200,300,400,500,600,700],0,341],
  ["Noto Sans Hebrew","sans-serif",[100,200,300,400,500,600,700,800,900],0,342],
  ["Quattrocento","serif",[400,700],0,343],
  ["Paytone One","sans-serif",[400],0,344],
  ["Gilda Display","serif",[400],0,345],
  ["Faustina","serif",[300,400,500,600,700,800],1,347],
  ["PT Sans Caption","sans-serif",[400,700],0,348],
  ["Playball","display",[400],0,349],
  ["Didact Gothic","sans-serif",[400],0,350],
  ["Ubuntu Condensed","sans-serif",[400],0,351],
  ["Tangerine","handwriting",[400,700],0,352],
  ["Concert One","display",[400],0,353],
  ["Playfair Display SC","serif",[400,700,900],1,354],
  ["M PLUS 1","sans-serif",[100,200,300,400,500,600,700,800,900],0,355],
  ["Neuton","serif",[200,300,400,700,800],1,356],
  ["Noto Serif Bengali","serif",[100,200,300,400,500,600,700,800,900],0,357],
  ["Anek Bangla","sans-serif",[100,200,300,400,500,600,700,800],0,358],
  ["Encode Sans Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],0,359],
  ["Saira Extra Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],0,360],
  ["Gloria Hallelujah","handwriting",[400],0,361],
  ["Quattrocento Sans","sans-serif",[400,700],1,362],
  ["Hind Guntur","sans-serif",[300,400,500,600,700],0,363],
  ["Abhaya Libre","serif",[400,500,600,700,800],0,364],
  ["Quantico","sans-serif",[400,700],1,365],
  ["Radio Canada","sans-serif",[300,400,500,600,700],1,366],
  ["Nanum Pen Script","handwriting",[400],0,367],
  ["Pathway Gothic One","sans-serif",[400],0,368],
  ["Jersey 25","display",[400],0,370],
  ["Poiret One","display",[400],0,371],
  ["Sofia Sans Extra Condensed","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],1,372],
  ["Audiowide","display",[400],0,373],
  ["Lusitana","serif",[400,700],0,374],
  ["PT Mono","monospace",[400],0,375],
  ["Italianno","handwriting",[400],0,377],
  ["Dela Gothic One","display",[400],0,378],
  ["Sanchez","serif",[400],1,379],
  ["Parisienne","handwriting",[400],0,380],
  ["Cinzel Decorative","display",[400,700,900],0,381],
  ["Architects Daughter","handwriting",[400],0,384],
  ["El Messiri","sans-serif",[400,500,600,700],0,385],
  ["Noto Sans Malayalam","sans-serif",[100,200,300,400,500,600,700,800,900],0,387],
  ["Oleo Script","display",[400,700],0,388],
  ["Cookie","handwriting",[400],0,389],
  ["Noto Sans HK","sans-serif",[100,200,300,400,500,600,700,800,900],0,390],
  ["Homemade Apple","handwriting",[400],0,391],
  ["Familjen Grotesk","sans-serif",[400,500,600,700],1,397],
  ["Pinyon Script","handwriting",[400],0,398],
  ["Arsenal","sans-serif",[400,700],1,399],
  ["Yeseva One","display",[400],0,400],
  ["Alex Brush","handwriting",[400],0,401],
  ["Merienda","handwriting",[300,400,500,600,700,800,900],0,402],
  ["Sorts Mill Goudy","serif",[400],1,404],
  ["Black Han Sans","sans-serif",[400],0,405],
  ["Vazirmatn","sans-serif",[100,200,300,400,500,600,700,800,900],0,406],
  ["Monda","sans-serif",[400,500,600,700],0,407],
  ["Blinker","sans-serif",[100,200,300,400,600,700,800,900],0,408],
  ["Lustria","serif",[400],0,409],
  ["Lalezar","sans-serif",[400],0,410],
  ["Mona Sans","sans-serif",[200,300,400,500,600,700,800,900],1,411],
  ["Chiron GoRound TC","sans-serif",[200,300,400,500,600,700,800,900],0,412],
  ["Goldman","display",[400,700],0,413],
  ["Amita","handwriting",[400,700],0,414],
  ["Cutive Mono","monospace",[400],0,415],
  ["Istok Web","sans-serif",[400,700],1,416],
  ["GFS Didot","serif",[400],0,417],
  ["Mukta Malar","sans-serif",[200,300,400,500,600,700,800],0,418],
  ["Cormorant Infant","serif",[300,400,500,600,700],1,419],
  ["Zen Kaku Gothic Antique","sans-serif",[300,400,500,700,900],0,420],
  ["Pridi","serif",[200,300,400,500,600,700],0,421],
  ["Kaisei Decol","serif",[400,500,700],0,422],
  ["Belleza","sans-serif",[400],0,423],
  ["Syncopate","sans-serif",[400,700],0,424],
  ["Taviraj","serif",[100,200,300,400,500,600,700,800,900],1,425],
  ["Reenie Beanie","handwriting",[400],0,426],
  ["Alice","serif",[400],0,427],
  ["Petrona","serif",[100,200,300,400,500,600,700,800,900],1,428],
  ["Anonymous Pro","monospace",[400,700],1,429],
  ["Fira Sans Extra Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],1,430],
  ["Hind Vadodara","sans-serif",[300,400,500,600,700],0,431],
  ["Saira Semi Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],0,432],
  ["Zeyada","handwriting",[400],0,433],
  ["Ropa Sans","sans-serif",[400],1,434],
  ["Noto Sans Symbols","sans-serif",[100,200,300,400,500,600,700,800,900],0,435],
  ["Do Hyeon","sans-serif",[400],0,436],
  ["Akshar","sans-serif",[300,400,500,600,700],0,437],
  ["Varela","sans-serif",[400],0,438],
  ["Volkhov","serif",[400,700],1,439],
  ["Afacad","sans-serif",[400,500,600,700],1,440],
  ["Calistoga","display",[400],0,441],
  ["Eczar","serif",[400,500,600,700,800],0,442],
  ["Belanosima","sans-serif",[400,600,700],0,443],
  ["Averia Serif Libre","display",[300,400,700],1,444],
  ["REM","sans-serif",[100,200,300,400,500,600,700,800,900],1,445],
  ["Caveat Brush","handwriting",[400],0,446],
  ["Vidaloka","serif",[400],0,447],
  ["Bowlby One SC","display",[400],0,448],
  ["IBM Plex Sans Thai","sans-serif",[100,200,300,400,500,600,700],0,449],
  ["Six Caps","sans-serif",[400],0,450],
  ["Lateef","serif",[200,300,400,500,600,700,800],0,451],
  ["Michroma","sans-serif",[400],0,452],
  ["Mada","sans-serif",[200,300,400,500,600,700,800,900],0,453],
  ["Noto Serif Display","serif",[100,200,300,400,500,600,700,800,900],1,454],
  ["Cuprum","sans-serif",[400,500,600,700],1,455],
  ["Ultra","serif",[400],0,456],
  ["Palanquin","sans-serif",[100,200,300,400,500,600,700],0,457],
  ["Host Grotesk","sans-serif",[300,400,500,600,700,800],1,458],
  ["Glegoo","serif",[400,700],0,459],
  ["Shippori Mincho B1","serif",[400,500,600,700,800],0,460],
  ["Bad Script","handwriting",[400],0,461],
  ["Ubuntu Mono","monospace",[400,700],1,462],
  ["Gudea","sans-serif",[400,700],1,463],
  ["Khula","sans-serif",[300,400,600,700,800],0,465],
  ["Pangolin","handwriting",[400],0,466],
  ["Pragati Narrow","sans-serif",[400,700],0,467],
  ["Koulen","display",[400],0,468],
  ["Jua","sans-serif",[400],0,469],
  ["Leckerli One","handwriting",[400],0,470],
  ["Reddit Sans","sans-serif",[200,300,400,500,600,700,800,900],1,471],
  ["Economica","sans-serif",[400,700],1,472],
  ["Sriracha","handwriting",[400],0,473],
  ["Handlee","handwriting",[400],0,474],
  ["Alegreya Sans SC","sans-serif",[100,300,400,500,700,800,900],1,475],
  ["Georama","sans-serif",[100,200,300,400,500,600,700,800,900],1,478],
  ["Mandali","sans-serif",[400],0,479],
  ["Julius Sans One","sans-serif",[400],0,480],
  ["Racing Sans One","display",[400],0,481],
  ["Limelight","display",[400],0,482],
  ["Niramit","sans-serif",[200,300,400,500,600,700],1,483],
  ["Gochi Hand","handwriting",[400],0,484],
  ["Murecho","sans-serif",[100,200,300,400,500,600,700,800,900],0,485],
  ["Fustat","sans-serif",[200,300,400,500,600,700,800],0,486],
  ["M PLUS 2","sans-serif",[100,200,300,400,500,600,700,800,900],0,487],
  ["Cabin Condensed","sans-serif",[400,500,600,700],0,489],
  ["Cedarville Cursive","handwriting",[400],0,490],
  ["Carter One","display",[400],0,491],
  ["Sofia","handwriting",[400],0,492],
  ["Adamina","serif",[400],0,493],
  ["Besley","serif",[400,500,600,700,800,900],1,494],
  ["Nothing You Could Do","handwriting",[400],0,495],
  ["Hachi Maru Pop","handwriting",[400],0,496],
  ["Arapey","serif",[400],1,497],
  ["Londrina Solid","display",[100,300,400,900],0,498],
  ["Suez One","serif",[400],0,499],
  ["Shrikhand","display",[400],0,501],
  ["Ruda","sans-serif",[400,500,600,700,800,900],0,502],
  ["Libre Barcode 128","display",[400],0,504],
  ["AR One Sans","sans-serif",[400,500,600,700],0,505],
  ["Potta One","display",[400],0,506],
  ["Damion","handwriting",[400],0,507],
  ["Marck Script","handwriting",[400],0,508],
  ["Noto Sans Gujarati","sans-serif",[100,200,300,400,500,600,700,800,900],0,509],
  ["Caprasimo","display",[400],0,510],
  ["Croissant One","display",[400],0,511],
  ["Dongle","sans-serif",[300,400,700],0,512],
  ["Overpass Mono","monospace",[300,400,500,600,700],0,513],
  ["Fira Mono","monospace",[400,500,700],0,514],
  ["Cairo Play","sans-serif",[200,300,400,500,600,700,800,900,1000],0,515],
  ["Squada One","display",[400],0,516],
  ["Mr Dafoe","handwriting",[400],0,517],
  ["Martel Sans","sans-serif",[200,300,400,600,700,800,900],0,518],
  ["Pirata One","display",[400],0,519],
  ["Syne Mono","monospace",[400],0,520],
  ["Pontano Sans","sans-serif",[300,400,500,600,700],0,521],
  ["Sansita","sans-serif",[400,700,800,900],1,522],
  ["Aldrich","sans-serif",[400],0,523],
  ["Wix Madefor Display","sans-serif",[400,500,600,700,800],0,524],
  ["Anuphan","sans-serif",[100,200,300,400,500,600,700],0,525],
  ["Palanquin Dark","sans-serif",[400,500,600,700],0,526],
  ["Proza Libre","sans-serif",[400,500,600,700,800],1,527],
  ["Rufina","serif",[400,700],0,528],
  ["Tilt Warp","display",[400],0,529],
  ["Chewy","display",[400],0,530],
  ["Italiana","sans-serif",[400],0,531],
  ["Lemonada","display",[300,400,500,600,700],0,532],
  ["Funnel Sans","sans-serif",[300,400,500,600,700,800],1,533],
  ["Basic","sans-serif",[400],0,534],
  ["Boogaloo","display",[400],0,535],
  ["Sansita Swashed","display",[300,400,500,600,700,800,900],0,536],
  ["MuseoModerno","display",[100,200,300,400,500,600,700,800,900],1,537],
  ["Bevan","serif",[400],1,538],
  ["Aboreto","display",[400],0,539],
  ["Secular One","sans-serif",[400],0,540],
  ["Kiwi Maru","serif",[300,400,500],0,541],
  ["Spline Sans","sans-serif",[300,400,500,600,700],0,542],
  ["Bona Nova SC","serif",[400,700],1,543],
  ["Delius","handwriting",[400],0,544],
  ["Yuji Mai","serif",[400],0,545],
  ["Baloo Da 2","display",[400,500,600,700,800],0,546],
  ["Anek Latin","sans-serif",[100,200,300,400,500,600,700,800],0,547],
  ["Itim","handwriting",[400],0,548],
  ["Electrolize","sans-serif",[400],0,550],
  ["Charm","handwriting",[400,700],0,551],
  ["Mrs Saint Delafield","handwriting",[400],0,552],
  ["Nixie One","display",[400],0,553],
  ["Aclonica","sans-serif",[400],0,554],
  ["Inria Serif","serif",[300,400,700],1,555],
  ["Bowlby One","display",[400],0,556],
  ["Ms Madi","handwriting",[400],0,557],
  ["Reem Kufi","sans-serif",[400,500,600,700],0,558],
  ["Covered By Your Grace","handwriting",[400],0,559],
  ["Fahkwang","sans-serif",[200,300,400,500,600,700],1,560],
  ["Gloock","serif",[400],0,561],
  ["Cormorant Upright","serif",[300,400,500,600,700],0,562],
  ["Just Another Hand","handwriting",[400],0,563],
  ["BenchNine","sans-serif",[300,400,700],0,564],
  ["Andika","sans-serif",[400,700],1,565],
  ["Yrsa","serif",[300,400,500,600,700],1,566],
  ["K2D","sans-serif",[100,200,300,400,500,600,700,800],1,567],
  ["Bungee Shade","display",[400],0,568],
  ["UnifrakturMaguntia","display",[400],0,569],
  ["Neucha","handwriting",[400],0,570],
  ["Nanum Brush Script","handwriting",[400],0,571],
  ["Kreon","serif",[300,400,500,600,700],0,573],
  ["Protest Revolution","display",[400],0,574],
  ["La Belle Aurore","handwriting",[400],0,575],
  ["Noto Sans Sinhala","sans-serif",[100,200,300,400,500,600,700,800,900],0,576],
  ["Wix Madefor Text","sans-serif",[400,500,600,700,800],1,577],
  ["Charis SIL","serif",[400,700],1,578],
  ["BIZ UDGothic","sans-serif",[400,700],0,579],
  ["Mate","serif",[400],1,580],
  ["Grandstander","display",[100,200,300,400,500,600,700,800,900],1,581],
  ["Balsamiq Sans","display",[400,700],1,582],
  ["Judson","serif",[400,700],1,583],
  ["Marcellus SC","serif",[400],0,584],
  ["IM Fell English","serif",[400],1,585],
  ["Ovo","serif",[400],0,586],
  ["Darker Grotesque","sans-serif",[300,400,500,600,700,800,900],0,587],
  ["Krona One","sans-serif",[400],0,588],
  ["Athiti","sans-serif",[200,300,400,500,600,700],0,589],
  ["Coda","display",[400,800],0,590],
  ["Rye","display",[400],0,591],
  ["Young Serif","serif",[400],0,592],
  ["Tektur","display",[400,500,600,700,800,900],0,593],
  ["Days One","sans-serif",[400],0,595],
  ["Ephesis","handwriting",[400],0,596],
  ["Vina Sans","display",[400],0,597],
  ["Castoro","serif",[400],1,598],
  ["Fredericka the Great","display",[400],0,599],
  ["Corben","display",[400,700],0,600],
  ["Gowun Dodum","sans-serif",[400],0,601],
  ["Livvic","sans-serif",[100,200,300,400,500,600,700,900],1,602],
  ["Rampart One","display",[400],0,603],
  ["Laila","serif",[300,400,500,600,700],0,605],
  ["Noto Sans Meetei Mayek","sans-serif",[100,200,300,400,500,600,700,800,900],0,606],
  ["IBM Plex Sans Hebrew","sans-serif",[100,200,300,400,500,600,700],0,607],
  ["Geo","sans-serif",[400],1,609],
  ["Barriecito","display",[400],0,610],
  ["Herr Von Muellerhoff","handwriting",[400],0,611],
  ["Ma Shan Zheng","handwriting",[400],0,612],
  ["Nova Square","display",[400],0,613],
  ["Averia Libre","display",[300,400,700],1,614],
  ["Glory","sans-serif",[100,200,300,400,500,600,700,800],1,615],
  ["Parkinsans","sans-serif",[300,400,500,600,700,800],0,616],
  ["Bellota Text","display",[300,400,700],1,617],
  ["Rozha One","serif",[400],0,618],
  ["DotGothic16","sans-serif",[400],0,619],
  ["Noto Sans Kannada","sans-serif",[100,200,300,400,500,600,700,800,900],0,620],
  ["Metrophobic","sans-serif",[400],0,621],
  ["Podkova","serif",[400,500,600,700,800],0,622],
  ["Noto Sans Gurmukhi","sans-serif",[100,200,300,400,500,600,700,800,900],0,623],
  ["Alef","sans-serif",[400,700],0,624],
  ["Noto Serif Khojki","serif",[400,500,600,700],0,625],
  ["Faster One","display",[400],0,626],
  ["Tiro Bangla","serif",[400],1,627],
  ["Quintessential","handwriting",[400],0,628],
  ["Sintony","sans-serif",[400,700],0,629],
  ["Atkinson Hyperlegible Next","sans-serif",[200,300,400,500,600,700,800],1,630],
  ["ZCOOL QingKe HuangYou","sans-serif",[400],0,631],
  ["Lexend Exa","sans-serif",[100,200,300,400,500,600,700,800,900],0,632],
  ["Radley","serif",[400],1,633],
  ["Pixelify Sans","display",[400,500,600,700],0,634],
  ["Shadows Into Light Two","handwriting",[400],0,635],
  ["Caudex","serif",[400,700],1,636],
  ["Sarala","sans-serif",[400,700],0,637],
  ["Grenze Gotisch","display",[100,200,300,400,500,600,700,800,900],0,638],
  ["Padauk","sans-serif",[400,700],0,639],
  ["Style Script","handwriting",[400],0,640],
  ["Andada Pro","serif",[400,500,600,700,800],1,641],
  ["Pathway Extreme","sans-serif",[100,200,300,400,500,600,700,800,900],1,642],
  ["Delius Unicase","handwriting",[400,700],0,643],
  ["Kosugi","sans-serif",[400],0,644],
  ["Trirong","serif",[100,200,300,400,500,600,700,800,900],1,645],
  ["Bellefair","serif",[400],0,646],
  ["Oranienbaum","serif",[400],0,647],
  ["Armata","sans-serif",[400],0,648],
  ["Niconne","handwriting",[400],0,649],
  ["Cabin Sketch","display",[400,700],0,650],
  ["Ubuntu Sans","sans-serif",[100,200,300,400,500,600,700,800],1,651],
  ["Spinnaker","sans-serif",[400],0,652],
  ["Oooh Baby","handwriting",[400],0,653],
  ["Yuji Syuku","serif",[400],0,654],
  ["Cormorant Unicase","serif",[300,400,500,600,700],0,655],
  ["Fragment Mono","monospace",[400],1,656],
  ["Noto Serif Devanagari","serif",[100,200,300,400,500,600,700,800,900],0,657],
  ["IBM Plex Sans KR","sans-serif",[100,200,300,400,500,600,700],0,658],
  ["Gowun Batang","serif",[400,700],0,659],
  ["Wallpoet","display",[400],0,660],
  ["Candal","sans-serif",[400],0,661],
  ["Alatsi","sans-serif",[400],0,662],
  ["Pattaya","sans-serif",[400],0,663],
  ["Azeret Mono","monospace",[100,200,300,400,500,600,700,800,900],1,664],
  ["Mochiy Pop One","sans-serif",[400],0,665],
  ["Klee One","handwriting",[400,600],0,667],
  ["Fjord One","serif",[400],0,668],
  ["Chonburi","display",[400],0,669],
  ["Special Gothic Condensed One","sans-serif",[400],0,670],
  ["Karma","serif",[300,400,500,600,700],0,671],
  ["Stardos Stencil","display",[400,700],0,672],
  ["Rakkas","display",[400],0,673],
  ["Mukta Vaani","sans-serif",[200,300,400,500,600,700,800],0,674],
  ["Norican","handwriting",[400],0,675],
  ["Hina Mincho","serif",[400],0,676],
  ["Big Shoulders","display",[100,200,300,400,500,600,700,800,900],0,677],
  ["Poller One","display",[400],0,678],
  ["Funnel Display","display",[300,400,500,600,700,800],0,679],
  ["Allerta Stencil","sans-serif",[400],0,680],
  ["Brygada 1918","serif",[400,500,600,700],1,681],
  ["Annie Use Your Telescope","handwriting",[400],0,682],
  ["BIZ UDPMincho","serif",[400,700],0,683],
  ["Knewave","display",[400],0,684],
  ["Cormorant SC","serif",[300,400,500,600,700],0,685],
  ["Gantari","sans-serif",[100,200,300,400,500,600,700,800,900],1,686],
  ["Tomorrow","sans-serif",[100,200,300,400,500,600,700,800,900],1,687],
  ["Tiro Devanagari Hindi","serif",[400],1,688],
  ["ADLaM Display","display",[400],0,689],
  ["PT Serif Caption","serif",[400],1,690],
  ["Cantata One","serif",[400],0,691],
  ["Allison","handwriting",[400],0,692],
  ["Hepta Slab","serif",[1,100,200,300,400,500,600,700,800,900],0,693],
  ["Arizonia","handwriting",[400],0,694],
  ["Kameron","serif",[400,500,600,700],0,695],
  ["Graduate","serif",[400],0,696],
  ["Antic Didone","serif",[400],0,697],
  ["Yatra One","display",[400],0,698],
  ["Grand Hotel","handwriting",[400],0,699],
  ["Hahmlet","serif",[100,200,300,400,500,600,700,800,900],0,700],
  ["Antic","sans-serif",[400],0,701],
  ["Mali","handwriting",[200,300,400,500,600,700],1,702],
  ["Jockey One","sans-serif",[400],0,703],
  ["Seaweed Script","display",[400],0,704],
  ["Nobile","sans-serif",[400,500,700],1,706],
  ["DynaPuff","display",[400,500,600,700],0,707],
  ["Noto Sans Oriya","sans-serif",[100,200,300,400,500,600,700,800,900],0,708],
  ["Irish Grover","display",[400],0,709],
  ["Red Hat Mono","monospace",[300,400,500,600,700],1,710],
  ["Mallanna","sans-serif",[400],0,711],
  ["Schoolbell","handwriting",[400],0,712],
  ["RocknRoll One","sans-serif",[400],0,713],
  ["Arbutus Slab","serif",[400],0,714],
  ["Baloo Thambi 2","display",[400,500,600,700,800],0,715],
  ["Lexend Peta","sans-serif",[100,200,300,400,500,600,700,800,900],0,716],
  ["Yusei Magic","sans-serif",[400],0,717],
  ["Sedgwick Ave Display","handwriting",[400],0,718],
  ["Playpen Sans","handwriting",[100,200,300,400,500,600,700,800],0,719],
  ["Zen Dots","display",[400],0,720],
  ["Radio Canada Big","sans-serif",[400,500,600,700],1,721],
  ["Honk","display",[400],0,722],
  ["Sofia Sans Semi Condensed","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],1,723],
  ["ZCOOL XiaoWei","sans-serif",[400],0,724],
  ["Petit Formal Script","handwriting",[400],0,725],
  ["Red Rose","display",[300,400,500,600,700],0,727],
  ["Lacquer","display",[400],0,728],
  ["Fondamento","handwriting",[400],1,729],
  ["Special Gothic Expanded One","sans-serif",[400],0,730],
  ["Caladea","serif",[400,700],1,731],
  ["Coming Soon","handwriting",[400],0,732],
  ["Kantumruy Pro","sans-serif",[100,200,300,400,500,600,700],1,733],
  ["Chivo Mono","monospace",[100,200,300,400,500,600,700,800,900],1,734],
  ["Bentham","serif",[400],0,735],
  ["Libre Caslon Display","serif",[400],0,736],
  ["Noto Sans Georgian","sans-serif",[100,200,300,400,500,600,700,800,900],0,737],
  ["Alegreya SC","serif",[400,500,700,800,900],1,738],
  ["Noto Sans Myanmar","sans-serif",[100,200,300,400,500,600,700,800,900],0,739],
  ["Anton SC","sans-serif",[400],0,741],
  ["Sniglet","display",[400,800],0,742],
  ["Almendra","serif",[400,700],1,743],
  ["Montagu Slab","serif",[100,200,300,400,500,600,700],0,744],
  ["Ibarra Real Nova","serif",[400,500,600,700],1,745],
  ["New Tegomin","serif",[400],0,746],
  ["Share","sans-serif",[400,700],1,747],
  ["Turret Road","display",[200,300,400,500,700,800],0,748],
  ["Goudy Bookletter 1911","serif",[400],0,749],
  ["Carlito","sans-serif",[400,700],1,750],
  ["Afacad Flux","sans-serif",[100,200,300,400,500,600,700,800,900,1000],0,751],
  ["Telex","sans-serif",[400],0,752],
  ["Kristi","handwriting",[400],0,753],
  ["ZCOOL KuaiLe","sans-serif",[400],0,754],
  ["Sarina","display",[400],0,755],
  ["Allerta","sans-serif",[400],0,756],
  ["Markazi Text","serif",[400,500,600,700],0,757],
  ["Major Mono Display","monospace",[400],0,758],
  ["Hanuman","serif",[100,200,300,400,500,600,700,800,900],0,759],
  ["Waiting for the Sunrise","handwriting",[400],0,760],
  ["Sigmar One","display",[400],0,761],
  ["Marmelad","sans-serif",[400],0,762],
  ["Special Gothic","sans-serif",[400,500,600,700],0,763],
  ["Amiko","sans-serif",[400,600,700],0,764],
  ["Magra","sans-serif",[400,700],0,765],
  ["Rancho","handwriting",[400],0,766],
  ["Halant","serif",[300,400,500,600,700],0,767],
  ["Contrail One","display",[400],0,768],
  ["IM Fell English SC","serif",[400],0,769],
  ["Monsieur La Doulaise","handwriting",[400],0,770],
  ["Fuzzy Bubbles","handwriting",[400,700],0,771],
  ["Over the Rainbow","handwriting",[400],0,772],
  ["Maitree","serif",[200,300,400,500,600,700],0,773],
  ["Noto Serif Hebrew","serif",[100,200,300,400,500,600,700,800,900],0,774],
  ["Marvel","sans-serif",[400,700],1,775],
  ["Agdasima","sans-serif",[400,700],0,776],
  ["Encode Sans Expanded","sans-serif",[100,200,300,400,500,600,700,800,900],0,777],
  ["Calligraffitti","handwriting",[400],0,778],
  ["Flow Circular","display",[400],0,779],
  ["Qwitcher Grypen","handwriting",[400,700],0,780],
  ["Zen Antique","serif",[400],0,781],
  ["Dawning of a New Day","handwriting",[400],0,782],
  ["Yesteryear","handwriting",[400],0,783],
  ["Fanwood Text","serif",[400],1,785],
  ["Enriqueta","serif",[400,500,600,700],0,786],
  ["Love Ya Like A Sister","display",[400],0,787],
  ["Jomhuria","display",[400],0,788],
  ["Mouse Memoirs","sans-serif",[400],0,789],
  ["Average Sans","sans-serif",[400],0,790],
  ["Inria Sans","sans-serif",[300,400,700],1,791],
  ["Slackey","display",[400],0,792],
  ["Agbalumo","display",[400],0,793],
  ["BioRhyme","serif",[200,300,400,500,600,700,800],0,794],
  ["Tilt Neon","display",[400],0,795],
  ["Noto Sans Ol Chiki","sans-serif",[400,500,600,700],0,796],
  ["Libre Barcode 39 Text","display",[400],0,797],
  ["Ruslan Display","display",[400],0,798],
  ["Rosario","sans-serif",[300,400,500,600,700],1,801],
  ["MedievalSharp","display",[400],0,802],
  ["Bubblegum Sans","display",[400],0,803],
  ["Kadwa","serif",[400,700],0,804],
  ["Oxygen Mono","monospace",[400],0,805],
  ["Zalando Sans Expanded","sans-serif",[200,300,400,500,600,700,800,900],1,806],
  ["Sometype Mono","monospace",[400,500,600,700],1,807],
  ["Anek Devanagari","sans-serif",[100,200,300,400,500,600,700,800],0,808],
  ["Overlock","display",[400,700,900],1,809],
  ["Kaisei Opti","serif",[400,500,700],0,810],
  ["Boldonse","display",[400],0,811],
  ["Bayon","sans-serif",[400],0,812],
  ["Anybody","display",[100,200,300,400,500,600,700,800,900],1,813],
  ["Encode Sans Semi Condensed","sans-serif",[100,200,300,400,500,600,700,800,900],0,814],
  ["Oleo Script Swash Caps","display",[400,700],0,815],
  ["Copse","serif",[400],0,816],
  ["Mountains of Christmas","display",[400,700],0,817],
  ["Rouge Script","handwriting",[400],0,818],
  ["Kurale","serif",[400],0,820],
  ["Averia Sans Libre","display",[300,400,700],1,822],
  ["Cal Sans","sans-serif",[400],0,823],
  ["Lekton","monospace",[400,700],1,824],
  ["IM Fell Double Pica","serif",[400],1,826],
  ["Metamorphous","display",[400],0,827],
  ["Bungee Inline","display",[400],0,828],
  ["Silkscreen","display",[400,700],0,829],
  ["Corinthia","handwriting",[400,700],0,830],
  ["Lexend Zetta","sans-serif",[100,200,300,400,500,600,700,800,900],0,831],
  ["Prosto One","display",[400],0,832],
  ["Spectral SC","serif",[200,300,400,500,600,700,800],1,833],
  ["Bokor","display",[400],0,834],
  ["Poetsen One","display",[400],0,835],
  ["Asul","serif",[400,700],0,836],
  ["Baloo Chettan 2","display",[400,500,600,700,800],0,837],
  ["Scada","sans-serif",[400,700],1,839],
  ["Edu SA Beginner","handwriting",[400,500,600,700],0,840],
  ["Gabriela","serif",[400],0,841],
  ["Asar","serif",[400],0,843],
  ["Viaoda Libre","display",[400],0,844],
  ["Denk One","sans-serif",[400],0,845],
  ["Sue Ellen Francisco","handwriting",[400],0,846],
  ["Moul","display",[400],0,847],
  ["Meddon","handwriting",[400],0,848],
  ["Battambang","display",[100,300,400,700,900],0,849],
  ["Meow Script","handwriting",[400],0,850],
  ["Monomaniac One","sans-serif",[400],0,851],
  ["SUSE","sans-serif",[100,200,300,400,500,600,700,800,900],1,852],
  ["Manjari","sans-serif",[100,400,700],0,853],
  ["Aref Ruqaa","serif",[400,700],0,854],
  ["Macondo","display",[400],0,855],
  ["Rambla","sans-serif",[400,700],1,856],
  ["Baloo Bhaijaan 2","display",[400,500,600,700,800],0,857],
  ["Xanh Mono","monospace",[400],1,858],
  ["Hurricane","handwriting",[400],0,859],
  ["Amarante","display",[400],0,860],
  ["Trocchi","serif",[400],0,861],
  ["Baloo Tamma 2","display",[400,500,600,700,800],0,862],
  ["Uncial Antiqua","display",[400],0,863],
  ["Bungee Spice","display",[400],0,864],
  ["Original Surfer","display",[400],0,865],
  ["Recursive","sans-serif",[300,400,500,600,700,800,900,1000],0,866],
  ["Megrim","display",[400],0,867],
  ["Average","serif",[400],0,868],
  ["Gurajada","sans-serif",[400],0,869],
  ["Rasa","serif",[300,400,500,600,700],1,870],
  ["Tenali Ramakrishna","sans-serif",[400],0,871],
  ["Rochester","handwriting",[400],0,872],
  ["Birthstone","handwriting",[400],0,873],
  ["Kodchasan","sans-serif",[200,300,400,500,600,700],1,874],
  ["Mansalva","handwriting",[400],0,876],
  ["Nova Mono","monospace",[400],0,877],
  ["Vast Shadow","serif",[400],0,878],
  ["Cherry Bomb One","display",[400],0,879],
  ["Encode Sans Semi Expanded","sans-serif",[100,200,300,400,500,600,700,800,900],0,880],
  ["Pliant","sans-serif",[100,200,300,400,500,600,700,800,900],1,881],
  ["Freehand","display",[400],0,882],
  ["Zen Kurenaido","sans-serif",[400],0,883],
  ["Coustard","serif",[400,900],0,884],
  ["Frijole","display",[400],0,886],
  ["IM Fell DW Pica","serif",[400],1,887],
  ["Hedvig Letters Serif","serif",[400],0,888],
  ["Baloo Paaji 2","display",[400,500,600,700,800],0,889],
  ["Buenard","serif",[400,500,600,700],0,890],
  ["Voltaire","sans-serif",[400],0,892],
  ["Vesper Libre","serif",[400,500,700,900],0,893],
  ["Rubik Dirt","display",[400],0,894],
  ["Zain","sans-serif",[200,300,400,700,800,900],1,895],
  ["Alike Angular","serif",[400],0,896],
  ["Quando","serif",[400],0,897],
  ["Doppio One","sans-serif",[400],0,898],
  ["KoHo","sans-serif",[200,300,400,500,600,700],1,899],
  ["Carrois Gothic","sans-serif",[400],0,900],
  ["Licorice","handwriting",[400],0,902],
  ["Inknut Antiqua","serif",[300,400,500,600,700,800,900],0,903],
  ["Julee","handwriting",[400],0,904],
  ["Doto","sans-serif",[100,200,300,400,500,600,700,800,900],0,905],
  ["Kalnia","serif",[100,200,300,400,500,600,700],0,906],
  ["Cambay","sans-serif",[400,700],1,907],
  ["David Libre","serif",[400,500,700],0,908],
  ["Carattere","handwriting",[400],0,909],
  ["Tienne","serif",[400,700,900],0,910],
  ["Walter Turncoat","handwriting",[400],0,911],
  ["Unkempt","display",[400,700],0,912],
  ["Zalando Sans","sans-serif",[200,300,400,500,600,700,800,900],1,913],
  ["IM Fell Double Pica SC","serif",[400],0,914],
  ["Baloo Bhai 2","display",[400,500,600,700,800],0,915],
  ["Tai Heritage Pro","serif",[400,700],0,916],
  ["Alike","serif",[400],0,917],
  ["Square Peg","handwriting",[400],0,918],
  ["Arima","display",[100,200,300,400,500,600,700],0,919],
  ["Gamja Flower","handwriting",[400],0,920],
  ["Aguafina Script","handwriting",[400],0,921],
  ["Fontdiner Swanky","display",[400],0,923],
  ["Aladin","display",[400],0,924],
  ["Vollkorn SC","serif",[400,600,700,900],0,925],
  ["Bakbak One","display",[400],0,926],
  ["Mukta Mahee","sans-serif",[200,300,400,500,600,700,800],0,927],
  ["Miriam Libre","sans-serif",[400,500,600,700],0,928],
  ["Spline Sans Mono","monospace",[300,400,500,600,700],1,929],
  ["Fuggles","handwriting",[400],0,930],
  ["Gaegu","handwriting",[300,400,700],0,931],
  ["Galada","display",[400],0,932],
  ["Zen Antique Soft","serif",[400],0,933],
  ["Inclusive Sans","sans-serif",[300,400,500,600,700],1,934],
  ["Capriola","sans-serif",[400],0,935],
  ["Gotu","sans-serif",[400],0,936],
  ["Supermercado One","display",[400],0,937],
  ["Finger Paint","display",[400],0,938],
  ["Della Respira","serif",[400],0,939],
  ["Fresca","sans-serif",[400],0,940],
  ["Coiny","display",[400],0,941],
  ["McLaren","display",[400],0,942],
  ["Jaldi","sans-serif",[400,700],0,943],
  ["B612 Mono","monospace",[400,700],1,944],
  ["Noto Sans Warang Citi","sans-serif",[400],0,945],
  ["Mohave","sans-serif",[300,400,500,600,700],1,946],
  ["Modak","display",[400],0,947],
  ["Expletus Sans","display",[400,500,600,700],1,948],
  ["Piazzolla","serif",[100,200,300,400,500,600,700,800,900],1,949],
  ["Amethysta","serif",[400],0,950],
  ["Esteban","serif",[400],0,951],
  ["Give You Glory","handwriting",[400],0,952],
  ["Cambo","serif",[400],0,953],
  ["Moon Dance","handwriting",[400],0,956],
  ["Platypi","serif",[300,400,500,600,700,800],1,957],
  ["Waterfall","handwriting",[400],0,958],
  ["Anek Malayalam","sans-serif",[100,200,300,400,500,600,700,800],0,959],
  ["Redressed","handwriting",[400],0,960],
  ["Road Rage","display",[400],0,961],
  ["Scheherazade New","serif",[400,500,600,700],0,962],
  ["MonteCarlo","handwriting",[400],0,963],
  ["Brawler","serif",[400,700],0,964],
  ["Cutive","serif",[400],0,965],
  ["Happy Monkey","display",[400],0,966],
  ["Stick No Bills","sans-serif",[200,300,400,500,600,700,800],0,967],
  ["TikTok Sans","sans-serif",[300,400,500,600,700,800,900],0,968],
  ["Aoboshi One","serif",[400],0,969],
  ["Poly","serif",[400],1,970],
  ["Allan","display",[400,700],0,971],
  ["Gluten","display",[100,200,300,400,500,600,700,800,900],0,972],
  ["BhuTuka Expanded One","serif",[400],0,973],
  ["Shantell Sans","display",[300,400,500,600,700,800],1,974],
  ["Mr De Haviland","handwriting",[400],0,975],
  ["Meie Script","handwriting",[400],0,976],
  ["Balthazar","serif",[400],0,977],
  ["Noto Serif Georgian","serif",[100,200,300,400,500,600,700,800,900],0,978],
  ["Atma","display",[300,400,500,600,700],0,979],
  ["Vibur","handwriting",[400],0,980],
  ["League Script","handwriting",[400],0,981],
  ["Orelega One","display",[400],0,982],
  ["Thasadith","sans-serif",[400,700],1,983],
  ["Reggae One","display",[400],0,984],
  ["LXGW WenKai TC","handwriting",[300,400,700],0,985],
  ["Molengo","sans-serif",[400],0,986],
  ["Ysabeau Office","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],1,987],
  ["Slabo 13px","serif",[400],0,988],
  ["Fauna One","serif",[400],0,989],
  ["Solitreo","handwriting",[400],0,990],
  ["Vujahday Script","handwriting",[400],0,991],
  ["Euphoria Script","handwriting",[400],0,992],
  ["Artifika","serif",[400],0,993],
  ["Rubik Glitch","display",[400],0,994],
  ["Noto Serif Thai","serif",[100,200,300,400,500,600,700,800,900],0,995],
  ["Sail","display",[400],0,997],
  ["Kelly Slab","display",[400],0,998],
  ["Montez","handwriting",[400],0,999],
  ["Madimi One","sans-serif",[400],0,1000],
  ["Pompiere","display",[400],0,1001],
  ["Port Lligat Sans","sans-serif",[400],0,1002],
  ["Bigshot One","display",[400],0,1003],
  ["Imprima","sans-serif",[400],0,1004],
  ["Qwigley","handwriting",[400],0,1005],
  ["Truculenta","sans-serif",[100,200,300,400,500,600,700,800,900],0,1006],
  ["Zalando Sans SemiExpanded","sans-serif",[200,300,400,500,600,700,800,900],1,1007],
  ["Anek Tamil","sans-serif",[100,200,300,400,500,600,700,800],0,1008],
  ["Wendy One","sans-serif",[400],0,1009],
  ["Oregano","display",[400],1,1010],
  ["Anta","sans-serif",[400],0,1011],
  ["Charmonman","handwriting",[400,700],0,1012],
  ["Iceberg","display",[400],0,1014],
  ["Shippori Antique","sans-serif",[400],0,1015],
  ["B612","sans-serif",[400,700],1,1016],
  ["Teachers","sans-serif",[400,500,600,700,800],1,1017],
  ["Rubik Doodle Shadow","display",[400],0,1018],
  ["Goblin One","display",[400],0,1019],
  ["Nata Sans","sans-serif",[100,200,300,400,500,600,700,800,900],0,1020],
  ["Crafty Girls","handwriting",[400],0,1021],
  ["Mina","sans-serif",[400,700],0,1022],
  ["Mooli","sans-serif",[400],0,1023],
  ["Geom","sans-serif",[300,400,500,600,700,800,900],1,1024],
  ["Kranky","display",[400],0,1025],
  ["Nova Round","display",[400],0,1026],
  ["Just Me Again Down Here","handwriting",[400],0,1027],
  ["Cherry Cream Soda","display",[400],0,1028],
  ["Sunshiney","handwriting",[400],0,1029],
  ["Mako","sans-serif",[400],0,1030],
  ["Nokora","sans-serif",[100,200,300,400,500,600,700,800,900],0,1032],
  ["Martian Mono","monospace",[100,200,300,400,500,600,700,800],0,1033],
  ["Lily Script One","display",[400],0,1034],
  ["New Rocker","display",[400],0,1035],
  ["NTR","sans-serif",[400],0,1036],
  ["Codystar","display",[300,400],0,1037],
  ["Kufam","sans-serif",[400,500,600,700,800,900],1,1038],
  ["Freeman","display",[400],0,1039],
  ["Skranji","display",[400,700],0,1040],
  ["Noto Sans Thai Looped","sans-serif",[100,200,300,400,500,600,700,800,900],0,1041],
  ["Wire One","sans-serif",[400],0,1042],
  ["Monofett","monospace",[400],0,1043],
  ["Holtwood One SC","serif",[400],0,1044],
  ["Bonheur Royale","handwriting",[400],0,1045],
  ["Bilbo Swash Caps","handwriting",[400],0,1046],
  ["Zhi Mang Xing","handwriting",[400],0,1047],
  ["Farro","sans-serif",[300,400,500,700],0,1048],
  ["Momo Signature","sans-serif",[400],0,1049],
  ["Clicker Script","handwriting",[400],0,1050],
  ["Arya","sans-serif",[400,700],0,1051],
  ["Ledger","serif",[400],0,1052],
  ["Solway","serif",[300,400,500,700,800],0,1053],
  ["Dynalight","display",[400],0,1054],
  ["Mirza","serif",[400,500,600,700],0,1055],
  ["Kablammo","display",[400],0,1056],
  ["The Girl Next Door","handwriting",[400],0,1057],
  ["Hi Melody","handwriting",[400],0,1058],
  ["Gasoek One","sans-serif",[400],0,1059],
  ["Nosifer","display",[400],0,1060],
  ["Loved by the King","handwriting",[400],0,1061],
  ["Sigmar","display",[400],0,1062],
  ["Libre Barcode 39 Extended Text","display",[400],0,1063],
  ["Bona Nova","serif",[400,700],1,1064],
  ["Suranna","serif",[400],0,1066],
  ["Comic Relief","display",[400,700],0,1067],
  ["Sedgwick Ave","handwriting",[400],0,1068],
  ["Sulphur Point","sans-serif",[300,400,700],0,1069],
  ["IM Fell French Canon","serif",[400],1,1070],
  ["Akatab","sans-serif",[400,500,600,700,800,900],0,1071],
  ["Protest Strike","display",[400],0,1072],
  ["Federo","sans-serif",[400],0,1073],
  ["Protest Riot","display",[400],0,1074],
  ["Inder","sans-serif",[400],0,1075],
  ["Abyssinica SIL","serif",[400],0,1076],
  ["Patrick Hand SC","handwriting",[400],0,1077],
  ["Elsie","display",[400,900],0,1078],
  ["Lavishly Yours","handwriting",[400],0,1079],
  ["Grenze","serif",[100,200,300,400,500,600,700,800,900],1,1080],
  ["Mochiy Pop P One","sans-serif",[400],0,1081],
  ["Shojumaru","display",[400],0,1082],
  ["M PLUS 1 Code","monospace",[100,200,300,400,500,600,700],0,1083],
  ["Metal Mania","display",[400],0,1084],
  ["Nerko One","handwriting",[400],0,1085],
  ["Whisper","handwriting",[400],0,1086],
  ["Sarpanch","sans-serif",[400,500,600,700,800,900],0,1087],
  ["Long Cang","handwriting",[400],0,1088],
  ["Numans","sans-serif",[400],0,1089],
  ["Noto Serif Tamil","serif",[100,200,300,400,500,600,700,800,900],1,1090],
  ["Salsa","display",[400],0,1091],
  ["Reddit Sans Condensed","sans-serif",[200,300,400,500,600,700,800,900],0,1092],
  ["Delicious Handrawn","handwriting",[400],0,1093],
  ["Noto Serif HK","serif",[200,300,400,500,600,700,800,900],0,1094],
  ["Shanti","sans-serif",[400],0,1095],
  ["Margarine","display",[400],0,1096],
  ["Germania One","display",[400],0,1097],
  ["Kaisei Tokumin","serif",[400,500,700,800],0,1099],
  ["Peralta","serif",[400],0,1100],
  ["Beth Ellen","handwriting",[400],0,1101],
  ["Sour Gummy","sans-serif",[100,200,300,400,500,600,700,800,900],1,1102],
  ["Prociono","serif",[400],0,1104],
  ["Atomic Age","display",[400],0,1105],
  ["Kode Mono","monospace",[400,500,600,700],0,1106],
  ["Trade Winds","display",[400],0,1107],
  ["Kavoon","display",[400],0,1108],
  ["Noto Sans Symbols 2","sans-serif",[400],0,1109],
  ["Noto Sans Lao","sans-serif",[100,200,300,400,500,600,700,800,900],0,1110],
  ["Ribeye","display",[400],0,1111],
  ["Lumanosimo","handwriting",[400],0,1112],
  ["Dangrek","display",[400],0,1113],
  ["Stick","sans-serif",[400],0,1114],
  ["Nova Flat","display",[400],0,1115],
  ["WindSong","handwriting",[400,500],0,1116],
  ["Noto Sans Armenian","sans-serif",[100,200,300,400,500,600,700,800,900],0,1117],
  ["Train One","display",[400],0,1118],
  ["Modern Antiqua","display",[400],0,1119],
  ["Ysabeau SC","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],0,1120],
  ["Bellota","display",[300,400,700],1,1121],
  ["Rubik Bubbles","display",[400],0,1122],
  ["Maiden Orange","serif",[400],0,1123],
  ["Baloo Bhaina 2","display",[400,500,600,700,800],0,1124],
  ["Sevillana","display",[400],0,1126],
  ["Sancreek","display",[400],0,1127],
  ["Badeen Display","display",[400],0,1128],
  ["Rationale","sans-serif",[400],0,1129],
  ["Crushed","display",[400],0,1130],
  ["Cherry Swash","display",[400,700],0,1131],
  ["Dokdo","display",[400],0,1132],
  ["Hubot Sans","sans-serif",[200,300,400,500,600,700,800,900],1,1133],
  ["Rosarivo","serif",[400],1,1134],
  ["Bagel Fat One","display",[400],0,1135],
  ["Montaga","serif",[400],0,1137],
  ["Manuale","serif",[300,400,500,600,700,800],1,1138],
  ["Fasthand","display",[400],0,1139],
  ["UnifrakturCook","display",[700],0,1140],
  ["The Nautigal","handwriting",[400,700],0,1141],
  ["Short Stack","handwriting",[400],0,1142],
  ["Life Savers","display",[400,700,800],0,1143],
  ["Swanky and Moo Moo","handwriting",[400],0,1144],
  ["Gentium Book Plus","serif",[400,700],1,1145],
  ["Chau Philomene One","sans-serif",[400],1,1146],
  ["Karantina","display",[300,400,700],0,1147],
  ["Gemunu Libre","sans-serif",[200,300,400,500,600,700,800],0,1148],
  ["IM Fell DW Pica SC","serif",[400],0,1149],
  ["IM Fell Great Primer","serif",[400],1,1150],
  ["Odibee Sans","display",[400],0,1151],
  ["Yomogi","handwriting",[400],0,1152],
  ["Akaya Kanadaka","display",[400],0,1153],
  ["Voces","sans-serif",[400],0,1155],
  ["Qahiri","sans-serif",[400],0,1156],
  ["Lemon","display",[400],0,1157],
  ["Baloo Tammudu 2","display",[400,500,600,700,800],0,1158],
  ["Gugi","display",[400],0,1159],
  ["Bitcount Single","display",[100,200,300,400,500,600,700,800,900],0,1160],
  ["Mozilla Text","sans-serif",[200,300,400,500,600,700],0,1161],
  ["Orienta","sans-serif",[400],0,1162],
  ["Nova Slim","display",[400],0,1163],
  ["Phudu","display",[300,400,500,600,700,800,900],0,1164],
  ["Victor Mono","monospace",[100,200,300,400,500,600,700],1,1165],
  ["Noto Sans Ethiopic","sans-serif",[100,200,300,400,500,600,700,800,900],0,1166],
  ["Spicy Rice","display",[400],0,1167],
  ["Baskervville SC","serif",[400,500,600,700],0,1168],
  ["Liter","sans-serif",[400],0,1169],
  ["Beau Rivage","handwriting",[400],0,1170],
  ["Anaheim","sans-serif",[400,500,600,700,800],0,1171],
  ["Genos","sans-serif",[100,200,300,400,500,600,700,800,900],1,1172],
  ["Kdam Thmor Pro","sans-serif",[400],0,1173],
  ["Macondo Swash Caps","display",[400],0,1174],
  ["Cantora One","sans-serif",[400],0,1176],
  ["Pavanam","sans-serif",[400],0,1177],
  ["Delius Swash Caps","handwriting",[400],0,1178],
  ["Harmattan","sans-serif",[400,500,600,700],0,1179],
  ["Raleway Dots","display",[400],0,1180],
  ["Caesar Dressing","display",[400],0,1181],
  ["Alan Sans","sans-serif",[300,400,500,600,700,800,900],0,1182],
  ["Sumana","serif",[400,700],0,1184],
  ["Poltawski Nowy","serif",[400,500,600,700],1,1185],
  ["Iceland","display",[400],0,1186],
  ["Trispace","sans-serif",[100,200,300,400,500,600,700,800],0,1187],
  ["Jolly Lodger","display",[400],0,1188],
  ["Duru Sans","sans-serif",[400],0,1189],
  ["Jersey 10","display",[400],0,1190],
  ["Asta Sans","sans-serif",[300,400,500,600,700,800],0,1191],
  ["Chicle","display",[400],0,1192],
  ["Cactus Classical Serif","serif",[400],0,1193],
  ["Edu TAS Beginner","handwriting",[400,500,600,700],0,1194],
  ["Baumans","display",[400],0,1195],
  ["Akronim","display",[400],0,1196],
  ["Homenaje","sans-serif",[400],0,1198],
  ["Asset","display",[400],0,1199],
  ["Carme","sans-serif",[400],0,1200],
  ["Libre Barcode 128 Text","display",[400],0,1201],
  ["Kenia","display",[400],0,1202],
  ["Bitcount Grid Double","display",[100,200,300,400,500,600,700,800,900],0,1203],
  ["Katibeh","display",[400],0,1204],
  ["Miltonian","display",[400],0,1205],
  ["Reddit Mono","monospace",[200,300,400,500,600,700,800,900],0,1206],
  ["Ruthie","handwriting",[400],0,1207],
  ["Eagle Lake","handwriting",[400],0,1209],
  ["Jomolhari","serif",[400],0,1210],
  ["Noto Serif Telugu","serif",[100,200,300,400,500,600,700,800,900],0,1211],
  ["Medula One","display",[400],0,1212],
  ["Alkalami","serif",[400],0,1213],
  ["IM Fell French Canon SC","serif",[400],0,1214],
  ["Smythe","display",[400],0,1215],
  ["BIZ UDMincho","serif",[400,700],0,1216],
  ["IM Fell Great Primer SC","serif",[400],0,1217],
  ["Notable","sans-serif",[400],0,1218],
  ["Diplomata","display",[400],0,1219],
  ["Gulzar","serif",[400],0,1220],
  ["Birthstone Bounce","handwriting",[400,500],0,1221],
  ["Jaro","sans-serif",[400],0,1222],
  ["Overlock SC","display",[400],0,1223],
  ["Unlock","display",[400],0,1224],
  ["Scope One","serif",[400],0,1225],
  ["Miniver","display",[400],0,1226],
  ["Barrio","display",[400],0,1227],
  ["Kulim Park","sans-serif",[200,300,400,600,700],1,1228],
  ["IBM Plex Sans Thai Looped","sans-serif",[100,200,300,400,500,600,700],0,1229],
  ["Gayathri","sans-serif",[100,400,700],0,1230],
  ["Noto Serif Malayalam","serif",[100,200,300,400,500,600,700,800,900],0,1231],
  ["Emilys Candy","display",[400],0,1232],
  ["Zen Tokyo Zoo","display",[400],0,1233],
  ["Tiro Devanagari Sanskrit","serif",[400],1,1235],
  ["Astloch","display",[400,700],0,1236],
  ["Convergence","sans-serif",[400],0,1237],
  ["Henny Penny","display",[400],0,1238],
  ["Freckle Face","display",[400],0,1239],
  ["Liu Jian Mao Cao","handwriting",[400],0,1240],
  ["Ceviche One","display",[400],0,1241],
  ["Yeon Sung","display",[400],0,1242],
  ["Luxurious Script","handwriting",[400],0,1243],
  ["Tauri","sans-serif",[400],0,1244],
  ["Grape Nuts","handwriting",[400],0,1245],
  ["Fascinate Inline","display",[400],0,1246],
  ["Redacted","display",[400],0,1247],
  ["Comme","sans-serif",[100,200,300,400,500,600,700,800,900],0,1248],
  ["Headland One","serif",[400],0,1250],
  ["Varta","sans-serif",[300,400,500,600,700],0,1251],
  ["Miltonian Tattoo","display",[400],0,1252],
  ["Stack Sans Text","sans-serif",[200,300,400,500,600,700],0,1253],
  ["Nova Cut","display",[400],0,1254],
  ["Chocolate Classical Sans","sans-serif",[400],0,1255],
  ["Fenix","serif",[400],0,1256],
  ["Alkatra","display",[400,500,600,700],0,1258],
  ["Nova Script","display",[400],0,1259],
  ["Fascinate","display",[400],0,1261],
  ["Noto Serif Kannada","serif",[100,200,300,400,500,600,700,800,900],0,1262],
  ["Zilla Slab Highlight","serif",[400,700],0,1264],
  ["Strait","sans-serif",[400],0,1265],
  ["Science Gothic","sans-serif",[100,200,300,400,500,600,700,800,900],0,1266],
  ["Nova Oval","display",[400],0,1267],
  ["Vampiro One","display",[400],0,1268],
  ["Belgrano","serif",[400],0,1269],
  ["Ballet","handwriting",[400],0,1270],
  ["Stalemate","handwriting",[400],0,1271],
  ["Borel","handwriting",[400],0,1272],
  ["East Sea Dokdo","handwriting",[400],0,1273],
  ["Gorditas","display",[400,700],0,1274],
  ["Stack Sans Headline","sans-serif",[200,300,400,500,600,700],0,1275],
  ["Timmana","sans-serif",[400],0,1276],
  ["Imbue","serif",[100,200,300,400,500,600,700,800,900],0,1277],
  ["Imperial Script","handwriting",[400],0,1279],
  ["Kavivanar","handwriting",[400],0,1280],
  ["Flamenco","display",[300,400],0,1281],
  ["Junge","serif",[400],0,1282],
  ["Ranchers","display",[400],0,1283],
  ["National Park","sans-serif",[200,300,400,500,600,700,800],0,1284],
  ["Tirra","sans-serif",[400,500,600,700,800,900],0,1285],
  ["Sansation","sans-serif",[300,400,700],1,1286],
  ["Gafata","sans-serif",[400],0,1287],
  ["Suwannaphum","serif",[100,300,400,700,900],0,1288],
  ["Ysabeau","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],1,1289],
  ["Noto Sans Grantha","sans-serif",[400],0,1290],
  ["Poor Story","display",[400],0,1291],
  ["Passions Conflict","handwriting",[400],0,1293],
  ["Mynerve","handwriting",[400],0,1294],
  ["Nabla","display",[400],0,1296],
  ["Mea Culpa","handwriting",[400],0,1298],
  ["Londrina Outline","display",[400],0,1299],
  ["Comforter","handwriting",[400],0,1300],
  ["Mystery Quest","display",[400],0,1301],
  ["Noto Sans Gunjala Gondi","sans-serif",[400,500,600,700],0,1302],
  ["Lugrasimo","handwriting",[400],0,1303],
  ["Engagement","handwriting",[400],0,1304],
  ["Erica One","display",[400],0,1305],
  ["Hedvig Letters Sans","sans-serif",[400],0,1307],
  ["Island Moments","handwriting",[400],0,1308],
  ["Braah One","sans-serif",[400],0,1309],
  ["IBM Plex Sans Devanagari","sans-serif",[100,200,300,400,500,600,700],0,1310],
  ["Odor Mean Chey","serif",[400],0,1311],
  ["Srisakdi","display",[400,700],0,1312],
  ["Anek Gujarati","sans-serif",[100,200,300,400,500,600,700,800],0,1315],
  ["Rubik Scribble","display",[400],0,1316],
  ["Gupter","serif",[400,500,700],0,1317],
  ["Carrois Gothic SC","sans-serif",[400],0,1318],
  ["Arbutus","serif",[400],0,1319],
  ["Devonshire","handwriting",[400],0,1320],
  ["Rum Raisin","sans-serif",[400],0,1321],
  ["Underdog","display",[400],0,1322],
  ["Manufacturing Consent","display",[400],0,1323],
  ["Sree Krushnadevaraya","serif",[400],0,1325],
  ["Lexend Mega","sans-serif",[100,200,300,400,500,600,700,800,900],0,1326],
  ["Noto Sans Thaana","sans-serif",[100,200,300,400,500,600,700,800,900],0,1327],
  ["Girassol","display",[400],0,1328],
  ["Kapakana","handwriting",[300,400],0,1329],
  ["Tac One","sans-serif",[400],0,1330],
  ["Caramel","handwriting",[400],0,1332],
  ["TASA Orbiter","sans-serif",[400,500,600,700,800],0,1334],
  ["Noto Sans Bhaiksuki","sans-serif",[400],0,1336],
  ["Akaya Telivigala","display",[400],0,1337],
  ["Sura","serif",[400,700],0,1338],
  ["Playpen Sans Arabic","handwriting",[100,200,300,400,500,600,700,800],0,1340],
  ["Sono","sans-serif",[200,300,400,500,600,700,800],0,1341],
  ["Faculty Glyphic","sans-serif",[400],0,1342],
  ["Noto Sans Buhid","sans-serif",[400],0,1343],
  ["Geostar Fill","display",[400],0,1345],
  ["Winky Sans","sans-serif",[300,400,500,600,700,800,900],1,1347],
  ["Smooch","handwriting",[400],0,1348],
  ["Port Lligat Slab","serif",[400],0,1349],
  ["Noto Sans Tagalog","sans-serif",[400],0,1350],
  ["Shippori Antique B1","sans-serif",[400],0,1352],
  ["Bruno Ace","display",[400],0,1353],
  ["Habibi","serif",[400],0,1354],
  ["Gwendolyn","handwriting",[400,700],0,1355],
  ["Festive","handwriting",[400],0,1357],
  ["Edu NSW ACT Cursive","handwriting",[400,500,600,700],0,1358],
  ["Mate SC","serif",[400],0,1359],
  ["Edu AU VIC WA NT Guides","handwriting",[400,500,600,700],0,1360],
  ["Marhey","display",[300,400,500,600,700],0,1362],
  ["Paprika","display",[400],0,1363],
  ["Cagliostro","sans-serif",[400],0,1364],
  ["Stint Ultra Condensed","serif",[400],0,1365],
  ["Kaisei HarunoUmi","serif",[400,500,700],0,1366],
  ["Averia Gruesa Libre","display",[400],0,1367],
  ["Tiny5","sans-serif",[400],0,1368],
  ["Seymour One","sans-serif",[400],0,1369],
  ["Climate Crisis","display",[400],0,1370],
  ["Cute Font","display",[400],0,1372],
  ["Joan","serif",[400],0,1374],
  ["Ysabeau Infant","sans-serif",[1,100,200,300,400,500,600,700,800,900,1000],1,1375],
  ["Noto Music","sans-serif",[400],0,1376],
  ["Noto Sans Gothic","sans-serif",[400],0,1377],
  ["Yuji Boku","serif",[400],0,1378],
  ["Ruluko","sans-serif",[400],0,1379],
  ["Spirax","display",[400],0,1380],
  ["Amiri Quran","serif",[400],0,1381],
  ["Sonsie One","display",[400],0,1382],
  ["Tiro Devanagari Marathi","serif",[400],1,1383],
  ["Englebert","sans-serif",[400],0,1385],
  ["Lovers Quarrel","handwriting",[400],0,1386],
  ["Moderustic","sans-serif",[300,400,500,600,700,800],0,1387],
  ["Almendra SC","serif",[400],0,1389],
  ["Bilbo","handwriting",[400],0,1391],
  ["Alien Block","display",[400],0,1392],
  ["Mozilla Headline","sans-serif",[200,300,400,500,600,700],0,1393],
  ["Big Shoulders Stencil","display",[100,200,300,400,500,600,700,800,900],0,1394],
  ["Rubik Moonrocks","display",[400],0,1395],
  ["BBH Bartle","sans-serif",[400],0,1396],
  ["Anek Kannada","sans-serif",[100,200,300,400,500,600,700,800],0,1397],
  ["Rubik Wet Paint","display",[400],0,1398],
  ["Montserrat Underline","sans-serif",[100,200,300,400,500,600,700,800,900],1,1399],
  ["Linden Hill","serif",[400],1,1400],
  ["Monomakh","display",[400],0,1401],
  ["Texturina","serif",[100,200,300,400,500,600,700,800,900],1,1402],
  ["Ewert","display",[400],0,1403],
  ["Bruno Ace SC","display",[400],0,1404],
  ["Tillana","display",[400,500,600,700,800],0,1405],
  ["WDXL Lubrifont JP N","sans-serif",[400],0,1406],
  ["Stoke","serif",[300,400],0,1407],
  ["My Soul","handwriting",[400],0,1408],
  ["Text Me One","sans-serif",[400],0,1409],
  ["Handjet","display",[100,200,300,400,500,600,700,800,900],0,1410],
  ["Foldit","display",[100,200,300,400,500,600,700,800,900],0,1411],
  ["Reem Kufi Fun","sans-serif",[400,500,600,700],0,1412],
  ["Kite One","sans-serif",[400],0,1413],
  ["Jacquard 12","display",[400],0,1414],
  ["Noto Sans Tai Viet","sans-serif",[400],0,1415],
  ["Noto Serif Ahom","serif",[400],0,1416],
  ["Glass Antiqua","display",[400],0,1417],
  ["Milonga","display",[400],0,1418],
  ["Buda","display",[300],0,1419],
  ["Tourney","display",[100,200,300,400,500,600,700,800,900],1,1420],
  ["Beiruti","sans-serif",[200,300,400,500,600,700,800,900],0,1421],
  ["Keania One","display",[400],0,1423],
  ["Stint Ultra Expanded","serif",[400],0,1424],
  ["Meera Inimai","sans-serif",[400],0,1425],
  ["Koh Santepheap","serif",[100,300,400,700,900],0,1426],
  ["Story Script","sans-serif",[400],0,1427],
  ["Farsan","display",[400],0,1428],
  ["Libre Barcode EAN13 Text","display",[400],0,1429],
  ["Alumni Sans Pinstripe","sans-serif",[400],1,1430],
  ["Condiment","handwriting",[400],0,1431],
  ["Romanesco","handwriting",[400],0,1433],
  ["Ravi Prakash","display",[400],0,1434],
  ["Smokum","display",[400],0,1435],
  ["Galindo","display",[400],0,1436],
  ["Water Brush","handwriting",[400],0,1437],
  ["Gentium Plus","serif",[400,700],1,1438],
  ["Noto Sans Canadian Aboriginal","sans-serif",[100,200,300,400,500,600,700,800,900],0,1440],
  ["Risque","display",[400],0,1441],
  ["Yaldevi","sans-serif",[200,300,400,500,600,700],0,1442],
  ["Comforter Brush","handwriting",[400],0,1444],
  ["Anek Odia","sans-serif",[100,200,300,400,500,600,700,800],0,1445],
  ["Dekko","handwriting",[400],0,1446],
  ["Bodoni Moda SC","serif",[400,500,600,700,800,900],1,1447],
  ["Elms Sans","sans-serif",[100,200,300,400,500,600,700,800,900],1,1448],
  ["Ramaraja","serif",[400],0,1449],
  ["Offside","display",[400],0,1450],
  ["Edu AU VIC WA NT Hand","handwriting",[400,500,600,700],0,1451],
  ["Darumadrop One","display",[400],0,1452],
  ["Simonetta","display",[400,900],1,1453],
  ["Inika","serif",[400,700],0,1454],
  ["Huninn","sans-serif",[400],0,1455],
  ["Jacques Francois Shadow","display",[400],0,1456],
  ["Castoro Titling","display",[400],0,1458],
  ["Stalinist One","display",[400],0,1460],
  ["Tilt Prism","display",[400],0,1461],
  ["Bitcount Prop Single","display",[100,200,300,400,500,600,700,800,900],0,1462],
  ["Shalimar","handwriting",[400],0,1463],
  ["Metal","display",[400],0,1464],
  ["Orbit","sans-serif",[400],0,1465],
  ["Noto Serif Armenian","serif",[100,200,300,400,500,600,700,800,900],0,1466],
  ["Micro 5","display",[400],0,1467],
  ["Mrs Sheppards","handwriting",[400],0,1468],
  ["Grey Qo","handwriting",[400],0,1469],
  ["Sirin Stencil","display",[400],0,1470],
  ["Luxurious Roman","display",[400],0,1471],
  ["Momo Trust Display","sans-serif",[400],0,1472],
  ["Plaster","display",[400],0,1473],
  ["Trykker","serif",[400],0,1474],
  ["Encode Sans SC","sans-serif",[100,200,300,400,500,600,700,800,900],0,1475],
  ["Autour One","display",[400],0,1476],
  ["Benne","serif",[400],0,1477],
  ["Momo Trust Sans","sans-serif",[200,300,400,500,600,700,800],0,1478],
  ["Jacques Francois","serif",[400],0,1479],
  ["Donegal One","serif",[400],0,1480],
  ["Mogra","display",[400],0,1481],
  ["Ojuju","sans-serif",[200,300,400,500,600,700,800],0,1482],
  ["Dai Banna SIL","serif",[300,400,500,600,700],1,1483],
  ["SN Pro","sans-serif",[200,300,400,500,600,700,800,900],1,1484],
  ["Kotta One","serif",[400],0,1485],
  ["Lexend Tera","sans-serif",[100,200,300,400,500,600,700,800,900],0,1486],
  ["Fruktur","display",[400],1,1487],
  ["Noto Sans Anatolian Hieroglyphs","sans-serif",[400],0,1488],
  ["Noto Sans Batak","sans-serif",[400],0,1489],
  ["Tiro Gurmukhi","serif",[400],1,1490],
  ["Dorsa","sans-serif",[400],0,1491],
  ["Tiro Kannada","serif",[400],1,1493],
  ["Noto Sans Osmanya","sans-serif",[400],0,1494],
  ["Marko One","serif",[400],0,1495],
  ["Londrina Shadow","display",[400],0,1496],
  ["Joti One","display",[400],0,1498],
  ["Purple Purse","display",[400],0,1499],
  ["Nuosu SIL","sans-serif",[400],0,1500],
  ["Tulpen One","display",[400],0,1501],
  ["Ancizar Serif","serif",[300,400,500,600,700,800,900],1,1502],
  ["Piedra","display",[400],0,1503],
  ["Rubik Gemstones","display",[400],0,1504],
  ["Cascadia Code","sans-serif",[200,300,400,500,600,700],1,1505],
  ["Noto Sans Linear A","sans-serif",[400],0,1506],
  ["Ancizar Sans","sans-serif",[100,200,300,400,500,600,700,800,900,1000],1,1508],
  ["Anek Gurmukhi","sans-serif",[100,200,300,400,500,600,700,800],0,1509],
  ["Libertinus Sans","sans-serif",[400,700],1,1510],
  ["Dhurjati","sans-serif",[400],0,1511],
  ["Rubik Pixels","display",[400],0,1512],
  ["Wittgenstein","serif",[400,500,600,700,800,900],1,1514],
  ["Ribeye Marrow","display",[400],0,1515],
  ["Fleur De Leah","handwriting",[400],0,1516],
  ["Vend Sans","sans-serif",[300,400,500,600,700],1,1517],
  ["Lancelot","display",[400],0,1518],
  ["Noto Sans Sora Sompeng","sans-serif",[400,500,600,700],0,1519],
  ["Uchen","serif",[400],0,1520],
  ["GFS Neohellenic","sans-serif",[400,700],1,1522],
  ["Arsenal SC","sans-serif",[400,700],1,1523],
  ["Chilanka","handwriting",[400],0,1524],
  ["Neonderthaw","handwriting",[400],0,1525],
  ["Wellfleet","serif",[400],0,1526],
  ["Rubik Spray Paint","display",[400],0,1527],
  ["Galdeano","sans-serif",[400],0,1528],
  ["Chiron Hei HK","sans-serif",[200,300,400,500,600,700,800,900],1,1529],
  ["Inspiration","handwriting",[400],0,1531],
  ["Chathura","sans-serif",[100,300,400,700,800],0,1532],
  ["Sixtyfour","monospace",[400],0,1533],
  ["Ranga","display",[400,700],0,1534],
  ["Noto Serif Gujarati","serif",[100,200,300,400,500,600,700,800,900],0,1535],
  ["Ponomar","display",[400],0,1536],
  ["Noto Serif Sinhala","serif",[100,200,300,400,500,600,700,800,900],0,1537],
  ["Butcherman","display",[400],0,1538],
  ["Emblema One","display",[400],0,1539],
  ["Konkhmer Sleokchher","display",[400],0,1541],
  ["Sofadi One","display",[400],0,1542],
  ["New Amsterdam","sans-serif",[400],0,1543],
  ["Hubballi","sans-serif",[400],0,1544],
  ["Kumar One","display",[400],0,1545],
  ["Griffy","display",[400],0,1546],
  ["Praise","handwriting",[400],0,1547],
  ["Elsie Swash Caps","display",[400,900],0,1548],
  ["Bungee Hairline","display",[400],0,1549],
  ["Federant","display",[400],0,1550],
  ["Epunda Sans","sans-serif",[300,400,500,600,700,800,900],1,1551],
  ["Noto Rashi Hebrew","serif",[100,200,300,400,500,600,700,800,900],0,1552],
  ["Sahitya","serif",[400,700],0,1553],
  ["Bungee Outline","display",[400],0,1554],
  ["Reem Kufi Ink","sans-serif",[400],0,1555],
  ["Libre Barcode 39 Extended","display",[400],0,1556],
  ["Lakki Reddy","handwriting",[400],0,1557],
  ["Noto Serif Khmer","serif",[100,200,300,400,500,600,700,800,900],0,1558],
  ["Revalia","display",[400],0,1559],
  ["Noto Serif Lao","serif",[100,200,300,400,500,600,700,800,900],0,1560],
  ["Noto Sans Samaritan","sans-serif",[400],0,1561],
  ["Bacasime Antique","serif",[400],0,1562],
  ["Send Flowers","handwriting",[400],0,1563],
  ["Gideon Roman","display",[400],0,1565],
  ["Atkinson Hyperlegible Mono","sans-serif",[200,300,400,500,600,700,800],1,1568],
  ["Rubik Distressed","display",[400],0,1569],
  ["Libertinus Serif","serif",[400,600,700],1,1570],
  ["Tiro Telugu","serif",[400],1,1571],
  ["Updock","handwriting",[400],0,1572],
  ["Bungee Tint","display",[400],0,1573],
  ["Molle","handwriting",[400],1,1574],
  ["Jersey 20","display",[400],0,1575],
  ["Bigelow Rules","display",[400],0,1576],
  ["Alumni Sans Collegiate One","sans-serif",[400],1,1577],
  ["Oi","display",[400],0,1578],
  ["Felipa","handwriting",[400],0,1579],
  ["Love Light","handwriting",[400],0,1580],
  ["Sedan SC","serif",[400],0,1581],
  ["Iansui","handwriting",[400],0,1583],
  ["Triodion","display",[400],0,1584],
  ["Winky Rough","sans-serif",[300,400,500,600,700,800,900],1,1585],
  ["Jersey 15","display",[400],0,1586],
  ["Preahvihear","sans-serif",[400],0,1587],
  ["Alumni Sans SC","sans-serif",[100,200,300,400,500,600,700,800,900],1,1588],
  ["Bubbler One","sans-serif",[400],0,1589],
  ["Almendra Display","display",[400],0,1590],
  ["Miss Fajardose","handwriting",[400],0,1591],
  ["Kirang Haerang","display",[400],0,1592],
  ["Mr Bedfort","handwriting",[400],0,1594],
  ["Alumni Sans Inline One","display",[400],1,1595],
  ["Chela One","display",[400],0,1596],
  ["Diplomata SC","display",[400],0,1597],
  ["Londrina Sketch","display",[400],0,1598],
  ["Passero One","display",[400],0,1599],
  ["Ole","handwriting",[400],0,1600],
  ["Noto Sans Lao Looped","sans-serif",[100,200,300,400,500,600,700,800,900],0,1601],
  ["Tsukimi Rounded","sans-serif",[300,400,500,600,700],0,1602],
  ["Dr Sugiyama","handwriting",[400],0,1603],
  ["Peddana","serif",[400],0,1605],
  ["Matemasie","sans-serif",[400],0,1606],
  ["Hanalei Fill","display",[400],0,1607],
  ["Twinkle Star","handwriting",[400],0,1608],
  ["Edu NSW ACT Foundation","handwriting",[400,500,600,700],0,1609],
  ["Aref Ruqaa Ink","serif",[400,700],0,1610],
  ["Cascadia Mono","sans-serif",[200,300,400,500,600,700],1,1611],
  ["Iosevka Charon","monospace",[300,400,500,700],1,1612],
  ["Jim Nightshade","handwriting",[400],0,1613],
  ["Sixtyfour Convergence","monospace",[400],0,1614],
  ["Princess Sofia","handwriting",[400],0,1615],
  ["Blaka","display",[400],0,1619],
  ["TASA Explorer","sans-serif",[400,500,600,700,800],0,1621],
  ["Noto Sans Tangsa","sans-serif",[400,500,600,700],0,1622],
  ["Bahiana","display",[400],0,1623],
  ["Rubik Iso","display",[400],0,1624],
  ["Edu VIC WA NT Beginner","handwriting",[400,500,600,700],0,1625],
  ["Ubuntu Sans Mono","monospace",[400,500,600,700],1,1626],
  ["BioRhyme Expanded","serif",[200,300,400,700,800],0,1628],
  ["Trochut","display",[400,700],1,1630],
  ["Noto Sans Adlam","sans-serif",[400,500,600,700],0,1631],
  ["Rubik 80s Fade","display",[400],0,1632],
  ["Tiro Tamil","serif",[400],1,1634],
  ["Shizuru","display",[400],0,1635],
  ["Kumar One Outline","display",[400],0,1636],
  ["Gidugu","sans-serif",[400],0,1637],
  ["Diphylleia","serif",[400],0,1638],
  ["Babylonica","handwriting",[400],0,1639],
  ["Bitcount Grid Single","display",[100,200,300,400,500,600,700,800,900],0,1640],
  ["Flavors","display",[400],0,1641],
  ["Sedan","serif",[400],1,1642],
  ["LXGW WenKai Mono TC","monospace",[300,400,700],0,1643],
  ["Akt","sans-serif",[100,200,300,400,500,600,700,800,900],0,1644],
  ["Rhodium Libre","serif",[400],0,1645],
  ["Noto Serif Tangut","serif",[400],0,1646],
  ["Jacquard 24","display",[400],0,1647],
  ["Oldenburg","display",[400],0,1648],
  ["Noto Sans Javanese","sans-serif",[400,500,600,700],0,1650],
  ["Sirivennela","sans-serif",[400],0,1651],
  ["Bonbon","handwriting",[400],0,1652],
  ["Snippet","sans-serif",[400],0,1653],
  ["M PLUS Code Latin","sans-serif",[100,200,300,400,500,600,700],0,1654],
  ["Gidole","sans-serif",[400],0,1656],
  ["Rubik Puddles","display",[400],0,1657],
  ["Rubik Vinyl","display",[400],0,1658],
  ["Cossette Texte","sans-serif",[400,700],0,1660],
  ["Are You Serious","handwriting",[400],0,1661],
  ["Kings","handwriting",[400],0,1662],
  ["Cossette Titre","sans-serif",[400,700],0,1663],
  ["Rubik Burned","display",[400],0,1664],
  ["Lunasima","sans-serif",[400,700],0,1665],
  ["Suravaram","serif",[400],0,1668],
  ["Edu AU VIC WA NT Dots","handwriting",[400,500,600,700],0,1669],
  ["Rubik Glitch Pop","display",[400],0,1670],
  ["Noto Serif Vithkuqi","serif",[400,500,600,700],0,1671],
  ["Grechen Fuemen","handwriting",[400],0,1674],
  ["Zen Loop","display",[400],1,1675],
  ["Langar","display",[400],0,1676],
  ["Sassy Frass","handwriting",[400],0,1677],
  ["Intel One Mono","monospace",[300,400,500,600,700],1,1678],
  ["Big Shoulders Inline","display",[100,200,300,400,500,600,700,800,900],0,1679],
  ["Noto Sans Multani","sans-serif",[400],0,1680],
  ["Noto Sans Hanunoo","sans-serif",[400],0,1681],
  ["Amarna","sans-serif",[100,200,300,400,500,600,700],1,1682],
  ["Jacquarda Bastarda 9","display",[400],0,1683],
  ["Syne Tactile","display",[400],0,1685],
  ["Protest Guerrilla","display",[400],0,1686],
  ["Ruwudu","serif",[400,500,600,700],0,1687],
  ["Vibes","display",[400],0,1688],
  ["WDXL Lubrifont SC","sans-serif",[400],0,1689],
  ["Flow Rounded","display",[400],0,1691],
  ["Rubik Marker Hatch","display",[400],0,1692],
  ["Noto Sans Carian","sans-serif",[400],0,1693],
  ["Parastoo","serif",[400,500,600,700],0,1694],
  ["Cause","handwriting",[100,200,300,400,500,600,700,800,900],0,1695],
  ["Tapestry","handwriting",[400],0,1696],
  ["Stack Sans Notch","sans-serif",[200,300,400,500,600,700],0,1697],
  ["Noto Sans Syriac","sans-serif",[100,200,300,400,500,600,700,800,900],0,1698],
  ["Kolker Brush","handwriting",[400],0,1699],
  ["Noto Sans Pahawh Hmong","sans-serif",[400],0,1700],
  ["Noto Sans Glagolitic","sans-serif",[400],0,1701],
  ["Splash","handwriting",[400],0,1702],
  ["Butterfly Kids","handwriting",[400],0,1703],
  ["Rubik Microbe","display",[400],0,1705],
  ["Rubik Beastly","display",[400],0,1706],
  ["Agu Display","display",[400],0,1707],
  ["Taprom","display",[400],0,1708],
  ["Libertinus Mono","monospace",[400],0,1709],
  ["Noto Serif Ethiopic","serif",[100,200,300,400,500,600,700,800,900],0,1710],
  ["Explora","handwriting",[400],0,1712],
  ["Tagesschrift","display",[400],0,1713],
  ["Cherish","handwriting",[400],0,1715],
  ["BBH Bogle","sans-serif",[400],0,1716],
  ["Combo","display",[400],0,1717],
  ["Aubrey","display",[400],0,1719],
  ["Estonia","handwriting",[400],0,1720],
  ["WDXL Lubrifont TC","sans-serif",[400],0,1721],
  ["Noto Sans Nabataean","sans-serif",[400],0,1722],
  ["Workbench","monospace",[400],0,1723],
  ["Noto Serif Tibetan","serif",[100,200,300,400,500,600,700,800,900],0,1724],
  ["SUSE Mono","sans-serif",[100,200,300,400,500,600,700,800],1,1725],
  ["Gajraj One","display",[400],0,1726],
  ["Black And White Picture","display",[400],0,1727],
  ["Annapurna SIL","serif",[400,700],0,1728],
  ["Redacted Script","display",[300,400,700],0,1729],
  ["Bitcount Ink","display",[100,200,300,400,500,600,700,800,900],0,1730],
  ["Moulpali","sans-serif",[400],0,1731],
  ["Chiron Sung HK","serif",[200,300,400,500,600,700,800,900],1,1732],
  ["Geostar","display",[400],0,1733],
  ["Edu AU VIC WA NT Pre","handwriting",[400,500,600,700],0,1734],
  ["Noto Serif Toto","serif",[400,500,600,700],0,1735],
  ["Noto Sans Meroitic","sans-serif",[400],0,1736],
  ["Noto Sans Shavian","sans-serif",[400],0,1737],
  ["Menbere","sans-serif",[100,200,300,400,500,600,700],0,1740],
  ["Kedebideri","sans-serif",[400,500,600,700,800,900],0,1741],
  ["Noto Sans Mongolian","sans-serif",[400],0,1742],
  ["Chokokutai","display",[400],0,1743],
  ["Moo Lah Lah","display",[400],0,1744],
  ["Noto Sans Yi","sans-serif",[400],0,1745],
  ["Flow Block","display",[400],0,1746],
  ["Sekuya","display",[400],0,1748],
  ["Petemoss","handwriting",[400],0,1750],
  ["BBH Hegarty","sans-serif",[400],0,1752],
  ["Noto Sans Nag Mundari","sans-serif",[400,500,600,700],0,1754],
  ["Slackside One","handwriting",[400],0,1755],
  ["LXGW Marker Gothic","sans-serif",[400],0,1756],
  ["Kalnia Glaze","display",[100,200,300,400,500,600,700],0,1757],
  ["Mingzat","sans-serif",[400],0,1759],
  ["Bahianita","display",[400],0,1761],
  ["Palette Mosaic","display",[400],0,1762],
  ["Labrada","serif",[100,200,300,400,500,600,700,800,900],1,1763],
  ["Ga Maamli","display",[400],0,1764],
  ["Noto Sans Kaithi","sans-serif",[400],0,1767],
  ["Alyamama","serif",[300,400,500,600,700,800,900],0,1768],
  ["Epunda Slab","serif",[300,400,500,600,700,800,900],1,1769],
  ["Savate","sans-serif",[200,300,400,500,600,700,800,900],1,1770],
  ["M PLUS U","sans-serif",[100,200,300,400,500,600,700,800,900],0,1772],
  ["Playpen Sans Hebrew","handwriting",[100,200,300,400,500,600,700,800],0,1773],
  ["Snowburst One","display",[400],0,1776],
  ["Moirai One","display",[400],0,1777],
  ["Playpen Sans Deva","handwriting",[100,200,300,400,500,600,700,800],0,1779],
  ["Noto Serif Balinese","serif",[400],0,1781],
  ["Noto Sans Duployan","sans-serif",[400,700],0,1782],
  ["Noto Sans Coptic","sans-serif",[400],0,1783],
  ["Danfo","serif",[400],0,1784],
  ["Noto Serif Dogra","serif",[400],0,1786],
  ["Noto Sans Cypro Minoan","sans-serif",[400],0,1787],
  ["Noto Sans New Tai Lue","sans-serif",[400,500,600,700],0,1788],
  ["Ruge Boogie","handwriting",[400],0,1790],
  ["Noto Sans Old Italic","sans-serif",[400],0,1791],
  ["Noto Sans Old North Arabian","sans-serif",[400],0,1792],
  ["Yuji Hentaigana Akari","handwriting",[400],0,1794],
  ["Rock 3D","display",[400],0,1795],
  ["Lilex","monospace",[100,200,300,400,500,600,700],1,1796],
  ["Noto Serif Yezidi","serif",[400,500,600,700],0,1797],
  ["Hind Mysuru","sans-serif",[300,400,500,600,700],0,1800],
  ["Ingrid Darling","handwriting",[400],0,1801],
  ["Datatype","monospace",[100,200,300,400,500,600,700,800,900],0,1802],
  ["Noto Sans Cherokee","sans-serif",[100,200,300,400,500,600,700,800,900],0,1804],
  ["Estedad","sans-serif",[100,200,300,400,500,600,700,800,900],0,1805],
  ["Asimovian","sans-serif",[400],0,1806],
  ["Saira Stencil","display",[100,200,300,400,500,600,700,800,900],1,1807],
  ["Iosevka Charon Mono","monospace",[300,400,500,700],1,1808],
  ["UoqMunThenKhung","serif",[400],0,1809],
  ["Noto Sans Vithkuqi","sans-serif",[400,500,600,700],0,1810],
  ["Rubik Doodle Triangles","display",[400],0,1811],
  ["Puppies Play","handwriting",[400],0,1813],
  ["Noto Sans Marchen","sans-serif",[400],0,1816],
  ["Noto Serif Makasar","serif",[400],0,1819],
  ["Noto Sans Khojki","sans-serif",[400],0,1820],
  ["Rubik Broken Fax","display",[400],0,1821],
  ["Bitcount","display",[100,200,300,400,500,600,700,800,900],0,1822],
  ["Bitcount Prop Double Ink","display",[100,200,300,400,500,600,700,800,900],0,1823],
  ["Coral Pixels","display",[400],0,1824],
  ["Noto Sans NKo","sans-serif",[400],0,1827],
  ["Noto Sans Sunuwar","sans-serif",[400],0,1828],
  ["Noto Sans Old Turkic","sans-serif",[400],0,1829],
  ["Noto Sans Old Permic","sans-serif",[400],0,1832],
  ["Noto Sans Adlam Unjoined","sans-serif",[400,500,600,700],0,1833],
  ["Noto Sans Egyptian Hieroglyphs","sans-serif",[400],0,1834],
  ["Noto Sans Medefaidrin","sans-serif",[400,500,600,700],0,1835],
  ["Lisu Bosa","serif",[200,300,400,500,600,700,800,900],1,1836],
  ["Grandiflora One","serif",[400],0,1837],
  ["Noto Sans Bamum","sans-serif",[400,500,600,700],0,1838],
  ["Noto Sans Takri","sans-serif",[400],0,1840],
  ["Miranda Sans","sans-serif",[400,500,600,700],1,1841],
  ["Edu SA Hand","handwriting",[400,500,600,700],0,1845],
  ["Bitcount Single Ink","display",[100,200,300,400,500,600,700,800,900],0,1846],
  ["Playpen Sans Thai","handwriting",[100,200,300,400,500,600,700,800],0,1847],
  ["Noto Sans Nandinagari","sans-serif",[400],0,1848],
  ["Noto Serif Gurmukhi","serif",[100,200,300,400,500,600,700,800,900],0,1850],
  ["Noto Sans Palmyrene","sans-serif",[400],0,1852],
  ["Hanalei","display",[400],0,1853],
  ["Noto Sans Syriac Eastern","sans-serif",[100,200,300,400,500,600,700,800,900],0,1855],
  ["Noto Traditional Nushu","sans-serif",[300,400,500,600,700],0,1857],
  ["Noto Serif Oriya","serif",[400,500,600,700],0,1858],
  ["Noto Sans Old Hungarian","sans-serif",[400],0,1859],
  ["Noto Serif Khitan Small Script","serif",[400],0,1860],
  ["Noto Sans Osage","sans-serif",[400],0,1861],
  ["Warnes","display",[400],0,1862],
  ["Blaka Hollow","display",[400],0,1863],
  ["Noto Sans Old Persian","sans-serif",[400],0,1864],
  ["Noto Sans Indic Siyaq Numbers","sans-serif",[400],0,1866],
  ["Noto Sans Avestan","sans-serif",[400],0,1867],
  ["Rubik Maps","display",[400],0,1868],
  ["Bytesized","sans-serif",[400],0,1870],
  ["Jaini","display",[400],0,1871],
  ["Edu QLD Beginner","handwriting",[400,500,600,700],0,1872],
  ["Noto Sans Lisu","sans-serif",[400,500,600,700],0,1873],
  ["Rubik Storm","display",[400],0,1874],
  ["Padyakke Expanded One","serif",[400],0,1876],
  ["Gveret Levin","handwriting",[400],0,1879],
  ["Rubik Lines","display",[400],0,1880],
  ["Blaka Ink","display",[400],0,1882],
  ["Bitcount Prop Double","display",[100,200,300,400,500,600,700,800,900],0,1883],
  ["Edu NSW ACT Hand Pre","handwriting",[400,500,600,700],0,1884],
  ["Noto Sans Syloti Nagri","sans-serif",[400],0,1885],
  ["Jacquard 12 Charted","display",[400],0,1886],
  ["Jaini Purva","display",[400],0,1887],
  ["Rubik Maze","display",[400],0,1888],
  ["Finlandica Text","sans-serif",[100,200,300,400,500,600,700,800,900],1,1889],
  ["Noto Sans Tifinagh","sans-serif",[400],0,1893],
  ["Libertinus Serif Display","display",[400],0,1895],
  ["Noto Sans Sundanese","sans-serif",[400,500,600,700],0,1896],
  ["Matangi","sans-serif",[300,400,500,600,700,800,900],0,1897],
  ["Noto Sans Elbasan","sans-serif",[400],0,1898],
  ["Noto Serif Ottoman Siyaq","serif",[400],0,1899],
  ["Noto Serif Hentaigana","serif",[200,300,400,500,600,700,800,900],0,1900],
  ["Maname","serif",[400],0,1903],
  ["Exile","display",[400],0,1904],
  ["Noto Serif Old Uyghur","serif",[400],0,1905],
  ["Noto Sans Wancho","sans-serif",[400],0,1906],
  ["Finlandica Headline","sans-serif",[100,200,300,400,500,600,700,800,900],1,1907],
  ["Narnoor","sans-serif",[400,500,600,700,800],0,1909],
  ["Noto Serif Todhri","serif",[400],0,1910],
  ["Noto Sans Tai Le","sans-serif",[400],0,1911],
  ["Noto Sans Balinese","sans-serif",[400,500,600,700],0,1915],
  ["Sankofa Display","sans-serif",[400],0,1916],
  ["Bpmf Huninn","sans-serif",[400],0,1919],
  ["Namdhinggo","serif",[400,500,600,700,800],0,1920],
  ["Noto Sans Mahajani","sans-serif",[400],0,1921],
  ["Noto Serif NP Hmong","serif",[400,500,600,700],0,1923],
  ["Edu AU VIC WA NT Arrows","handwriting",[400,500,600,700],0,1924],
  ["Noto Sans Cuneiform","sans-serif",[400],0,1925],
  ["Bitcount Grid Single Ink","display",[100,200,300,400,500,600,700,800,900],0,1926],
  ["Noto Sans Newa","sans-serif",[400],0,1927],
  ["Strichpunkt Sans","sans-serif",[400,500,600,700,800,900],0,1928],
  ["Shafarik","display",[400],0,1931],
  ["Bitcount Prop Single Ink","display",[100,200,300,400,500,600,700,800,900],0,1932],
  ["Libertinus Keyboard","display",[400],0,1933],
  ["Tuffy","sans-serif",[400,700],1,1936],
  ["Noto Sans PhagsPa","sans-serif",[400],0,1937],
  ["Kay Pho Du","serif",[400,500,600,700],0,1938],
  ["Noto Sans Buginese","sans-serif",[400],0,1939],
  ["Bitcount Grid Double Ink","display",[100,200,300,400,500,600,700,800,900],0,1940],
  ["Noto Znamenny Musical Notation","sans-serif",[400],0,1941],
  ["Ponnala","display",[400],0,1942],
  ["Noto Sans Lydian","sans-serif",[400],0,1943],
  ["Noto Sans Tirhuta","sans-serif",[400],0,1944],
  ["Noto Sans Brahmi","sans-serif",[400],0,1946],
  ["Noto Sans Imperial Aramaic","sans-serif",[400],0,1948],
  ["Noto Sans Sharada","sans-serif",[400],0,1950],
  ["Noto Sans NKo Unjoined","sans-serif",[400,500,600,700],0,1953],
  ["Idiqlat","serif",[200,300,400],0,1956],
  ["Noto Sans Tagbanwa","sans-serif",[400],0,1958],
  ["Noto Sans Linear B","sans-serif",[400],0,1959],
  ["Noto Sans Inscriptional Pahlavi","sans-serif",[400],0,1960],
  ["Noto Serif Grantha","serif",[400],0,1961],
  ["Noto Sans Runic","sans-serif",[400],0,1962],
  ["Noto Sans Chakma","sans-serif",[400],0,1963],
  ["Noto Sans Cham","sans-serif",[100,200,300,400,500,600,700,800,900],0,1964],
  ["Noto Sans Zanabazar Square","sans-serif",[400],0,1965],
  ["Noto Sans Sogdian","sans-serif",[400],0,1966],
  ["Edu QLD Hand","handwriting",[400,500,600,700],0,1968],
  ["Jacquard 24 Charted","display",[400],0,1971],
  ["Bpmf Iansui","handwriting",[400],0,1973],
  ["Noto Sans Miao","sans-serif",[400],0,1975],
  ["Noto Sans Old South Arabian","sans-serif",[400],0,1976],
  ["Jersey 10 Charted","display",[400],0,1977],
  ["Jersey 15 Charted","display",[400],0,1978],
  ["Bpmf Zihi Kai Std","sans-serif",[400],0,1979],
  ["Noto Sans Tai Tham","sans-serif",[400,500,600,700],0,1980],
  ["Betania Patmos","handwriting",[400],0,1981],
  ["Noto Serif Dives Akuru","serif",[400],0,1982],
  ["Noto Sans Hanifi Rohingya","sans-serif",[400,500,600,700],0,1983],
  ["Jersey 25 Charted","display",[400],0,1984],
  ["Yarndings 20","display",[400],0,1985],
  ["Noto Sans Ugaritic","sans-serif",[400],0,1987],
  ["Noto Sans Vai","sans-serif",[400],0,1988],
  ["Noto Sans Mayan Numerals","sans-serif",[400],0,1989],
  ["Betania Patmos In GDL","handwriting",[400],0,1990],
  ["Noto Sans Cypriot","sans-serif",[400],0,1992],
  ["Pochaevsk","display",[400],0,1995],
  ["Betania Patmos In","handwriting",[400],0,1996],
  ["Micro 5 Charted","display",[400],0,1997],
  ["Noto Sans Syriac Western","sans-serif",[100,200,300,400,500,600,700,800,900],0,1999],
  ["Betania Patmos GDL","handwriting",[400],0,2000],
  ["Noto Sans Kawi","sans-serif",[400,500,600,700],0,2001],
  ["Noto Sans Phoenician","sans-serif",[400],0,2004],
  ["Noto Sans Bassa Vah","sans-serif",[400,500,600,700],0,2006],
  ["Edu VIC WA NT Hand Pre","handwriting",[400,500,600,700],0,2007],
  ["Kanchenjunga","sans-serif",[400,500,600,700],0,2008],
  ["Noto Sans Rejang","sans-serif",[400],0,2009],
  ["Noto Sans Ogham","sans-serif",[400],0,2010],
  ["Noto Sans Inscriptional Parthian","sans-serif",[400],0,2011],
  ["Noto Sans Kayah Li","sans-serif",[400,500,600,700],0,2012],
  ["Noto Sans Caucasian Albanian","sans-serif",[400],0,2013],
  ["Jersey 20 Charted","display",[400],0,2014],
  ["Noto Sans Hatran","sans-serif",[400],0,2015],
  ["Edu VIC WA NT Hand","handwriting",[400,500,600,700],0,2016],
  ["Noto Sans SignWriting","sans-serif",[400],0,2017],
  ["Noto Sans Elymaic","sans-serif",[400],0,2018],
  ["Noto Sans Masaram Gondi","sans-serif",[400],0,2020],
  ["Yuji Hentaigana Akebono","handwriting",[400],0,2021],
  ["Noto Sans Mro","sans-serif",[400],0,2023],
  ["Noto Sans Tamil Supplement","sans-serif",[400],0,2024],
  ["Noto Sans Khudawadi","sans-serif",[400],0,2026],
  ["Noto Sans Nushu","sans-serif",[400],0,2030],
  ["Noto Sans Modi","sans-serif",[400],0,2031],
  ["Noto Sans Psalter Pahlavi","sans-serif",[400],0,2032],
  ["Jacquarda Bastarda 9 Charted","display",[400],0,2034],
  ["Noto Sans Pau Cin Hau","sans-serif",[400],0,2035],
  ["BJCree","serif",[400,500,600,700],0,2037],
  ["Noto Sans Limbu","sans-serif",[400],0,2040],
  ["Noto Sans Deseret","sans-serif",[400],0,2041],
  ["Noto Sans Soyombo","sans-serif",[400],0,2042],
  ["Noto Sans Old Sogdian","sans-serif",[400],0,2043],
  ["Noto Sans Saurashtra","sans-serif",[400],0,2045],
  ["Noto Sans Lepcha","sans-serif",[400],0,2047],
  ["Noto Sans Mende Kikakui","sans-serif",[400],0,2048],
  ["Noto Sans Chorasmian","sans-serif",[400],0,2050],
  ["Noto Sans Manichaean","sans-serif",[400],0,2053],
  ["Yarndings 12","display",[400],0,2055],
  ["Noto Sans Mandaic","sans-serif",[400],0,2056],
  ["Yarndings 20 Charted","display",[400],0,2057],
  ["Noto Sans Kharoshthi","sans-serif",[400],0,2059],
  ["Ramsina","serif",[400],0,2060],
  ["Yarndings 12 Charted","display",[400],0,2061],
  ["Noto Sans Siddham","sans-serif",[400],0,2063],
]
